/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const verifyAccountEmail = /* GraphQL */ `
  query VerifyAccountEmail($emailAddress: String!) {
    verifyAccountEmail(emailAddress: $emailAddress) {
      status
      orgID
      trialDaysRemaining
      trialLength
      features {
        type
        count
        __typename
      }
      __typename
    }
  }
`;
export const reverseGeocode = /* GraphQL */ `
  query ReverseGeocode($lat: Float!, $lon: Float!) {
    reverseGeocode(lat: $lat, lon: $lon) {
      formattedAddress
      lat
      lon
      matchType
      confidence
      distanceMeters
      source
      __typename
    }
  }
`;
export const addressesByRadius = /* GraphQL */ `
  query AddressesByRadius(
    $lat: Float!
    $lon: Float!
    $radiusMeters: Float!
    $limit: Int
  ) {
    addressesByRadius(
      lat: $lat
      lon: $lon
      radiusMeters: $radiusMeters
      limit: $limit
    ) {
      formattedAddress
      lat
      lon
      matchType
      confidence
      distanceMeters
      source
      __typename
    }
  }
`;
export const addressesByH3 = /* GraphQL */ `
  query AddressesByH3($h3Cells: [String!]!, $limit: Int) {
    addressesByH3(h3Cells: $h3Cells, limit: $limit) {
      formattedAddress
      lat
      lon
      matchType
      confidence
      distanceMeters
      source
      __typename
    }
  }
`;
export const getANDoorData = /* GraphQL */ `
  query GetANDoorData($input: ANDoorDataInput!) {
    getANDoorData(input: $input) {
      status
      ADDRESS_LINE_1
      CITY_PLAC
      STAT_ABBR
      RECD_ZIPC
      FNAM_FNAM
      SNAM_SNAM
      EST_AVAIL_EQTY_FULL
      pscs_score1
      ECHV_rng
      RCHR_BDAT
      LNGTH_OF_RES
      LU_INC_V6
      RSIZ_LASF
      MORT_DDATE
      householdIncome
      estimatedHouseValue
      estimatedEquity
      homeOwnerAge
      homeownerStatus
      homeSqFt
      creditRating
      __typename
    }
  }
`;
export const getIRAiReport = /* GraphQL */ `
  query GetIRAiReport(
    $latitude: Float!
    $longitude: Float!
    $requestId: String
  ) {
    getIRAiReport(
      latitude: $latitude
      longitude: $longitude
      requestId: $requestId
    ) {
      status
      message
      requestId
      __typename
    }
  }
`;
export const getMeasurementPrice = /* GraphQL */ `
  query GetMeasurementPrice($dealID: ID) {
    getMeasurementPrice(dealID: $dealID) {
      minPrice
      maxPrice
      currency
      productDetails {
        productId
        name
        price
        __typename
      }
      estimatedDelivery
      error
      errorCode
      __typename
    }
  }
`;
export const getMeasurementReport = /* GraphQL */ `
  query GetMeasurementReport($dealID: ID!) {
    getMeasurementReport(dealID: $dealID) {
      orderId
      eagleViewOrderId
      status
      dealID
      updatedAt
      errorSummary
      __typename
    }
  }
`;
export const getTaskListItems = /* GraphQL */ `
  query GetTaskListItems(
    $dealID: String!
    $taskListID: String
    $userID: String
    $autoCreate: Boolean
    $title: String
    $inspectionType: String
    $taskTypes: [String]
    $templateId: String
  ) {
    getTaskListItems(
      dealID: $dealID
      taskListID: $taskListID
      userID: $userID
      autoCreate: $autoCreate
      title: $title
      inspectionType: $inspectionType
      taskTypes: $taskTypes
      templateId: $templateId
    )
  }
`;
export const getStripeReceiptUrl = /* GraphQL */ `
  query GetStripeReceiptUrl($request: AWSJSON!) {
    getStripeReceiptUrl(request: $request)
  }
`;
export const stripeListPaymentMethods = /* GraphQL */ `
  query StripeListPaymentMethods($request: AWSJSON!) {
    stripeListPaymentMethods(request: $request)
  }
`;
export const getUserLastLoginReport = /* GraphQL */ `
  query GetUserLastLoginReport($request: AWSJSON!) {
    getUserLastLoginReport(request: $request)
  }
`;
export const getRecordingList = /* GraphQL */ `
  query GetRecordingList($request: AWSJSON!) {
    getRecordingList(request: $request)
  }
`;
export const listDocusealTemplates = /* GraphQL */ `
  query ListDocusealTemplates($request: AWSJSON!) {
    listDocusealTemplates(request: $request)
  }
`;
export const getKPIScorecardV2 = /* GraphQL */ `
  query GetKPIScorecardV2($userKey: ID!) {
    getKPIScorecardV2(userKey: $userKey)
  }
`;
export const listDoorsByAddress = /* GraphQL */ `
  query ListDoorsByAddress(
    $address: String!
    $lat: Float!
    $lon: Float!
    $distance: String!
  ) {
    listDoorsByAddress(
      address: $address
      lat: $lat
      lon: $lon
      distance: $distance
    )
  }
`;
export const listPinsInPolygon = /* GraphQL */ `
  query ListPinsInPolygon(
    $orgID: String!
    $lat: Float!
    $lon: Float!
    $polygon: AWSJSON!
    $size: Int
    $searchAfter: Float!
    $categoryID: ID!
    $lastVisited: String!
  ) {
    listPinsInPolygon(
      orgID: $orgID
      lat: $lat
      lon: $lon
      polygon: $polygon
      size: $size
      searchAfter: $searchAfter
      categoryID: $categoryID
      lastVisited: $lastVisited
    )
  }
`;
export const listPinsInRadius = /* GraphQL */ `
  query ListPinsInRadius(
    $orgID: String!
    $distance: String!
    $lat: Float!
    $lon: Float!
    $size: Int
    $searchAfter: Float!
    $categoryID: ID!
    $lastVisited: String!
  ) {
    listPinsInRadius(
      orgID: $orgID
      distance: $distance
      lat: $lat
      lon: $lon
      size: $size
      searchAfter: $searchAfter
      categoryID: $categoryID
      lastVisited: $lastVisited
    )
  }
`;
export const listPinsInRadiusAdvanced = /* GraphQL */ `
  query ListPinsInRadiusAdvanced(
    $orgID: String!
    $distance: String!
    $lat: Float!
    $lon: Float!
    $size: Int
    $searchAfter: Float!
    $stageID: String!
  ) {
    listPinsInRadiusAdvanced(
      orgID: $orgID
      distance: $distance
      lat: $lat
      lon: $lon
      size: $size
      searchAfter: $searchAfter
      stageID: $stageID
    )
  }
`;
export const listDoorsInPolygon = /* GraphQL */ `
  query ListDoorsInPolygon(
    $polygon: AWSJSON!
    $lat: Float!
    $lon: Float!
    $size: Int
    $searchAfter: Float!
  ) {
    listDoorsInPolygon(
      polygon: $polygon
      lat: $lat
      lon: $lon
      size: $size
      searchAfter: $searchAfter
    )
  }
`;
export const listDoorsInRadius = /* GraphQL */ `
  query ListDoorsInRadius(
    $distance: String!
    $lat: Float!
    $lon: Float!
    $size: Int
    $searchAfter: Float!
  ) {
    listDoorsInRadius(
      distance: $distance
      lat: $lat
      lon: $lon
      size: $size
      searchAfter: $searchAfter
    )
  }
`;
export const listBoundariesInEnvelope = /* GraphQL */ `
  query ListBoundariesInEnvelope(
    $minLon: Float!
    $maxLat: Float!
    $maxLon: Float!
    $minLat: Float!
  ) {
    listBoundariesInEnvelope(
      minLon: $minLon
      maxLat: $maxLat
      maxLon: $maxLon
      minLat: $minLat
    )
  }
`;
export const listBoundariesWithName = /* GraphQL */ `
  query ListBoundariesWithName($name: String!) {
    listBoundariesWithName(name: $name)
  }
`;
export const listAllDeals = /* GraphQL */ `
  query ListAllDeals($request: AWSJSON!) {
    listAllDeals(request: $request)
  }
`;
export const getLeaderboards = /* GraphQL */ `
  query GetLeaderboards($request: AWSJSON!) {
    getLeaderboards(request: $request)
  }
`;
export const getMyInfo = /* GraphQL */ `
  query GetMyInfo($request: AWSJSON!) {
    getMyInfo(request: $request)
  }
`;
export const listClosersForCircle = /* GraphQL */ `
  query ListClosersForCircle(
    $circleID: ID!
    $startDate: AWSDate!
    $endDate: AWSDate
    $desiredRole: String!
    $meetingLength: Int
    $fieldRoutesOfficeID: String
  ) {
    listClosersForCircle(
      circleID: $circleID
      startDate: $startDate
      endDate: $endDate
      desiredRole: $desiredRole
      meetingLength: $meetingLength
      fieldRoutesOfficeID: $fieldRoutesOfficeID
    )
  }
`;
export const listClosersForCircleV2 = /* GraphQL */ `
  query ListClosersForCircleV2(
    $circleID: ID!
    $startDate: AWSDate!
    $endDate: AWSDate
    $desiredRole: String!
    $meetingLength: Int
    $fieldRoutesOfficeID: String
  ) {
    listClosersForCircleV2(
      circleID: $circleID
      startDate: $startDate
      endDate: $endDate
      desiredRole: $desiredRole
      meetingLength: $meetingLength
      fieldRoutesOfficeID: $fieldRoutesOfficeID
    )
  }
`;
export const getKPIValuesV6 = /* GraphQL */ `
  query GetKPIValuesV6(
    $dimensionType: String!
    $dimensionTimeframe: String!
    $dimensionValue: String!
    $nextToken: String
    $limit: Int
    $sortColumn: String
    $sortOrder: String
    $circleLevelID: String
    $circleID: String
    $parentCircleID: String
    $viewID: String
  ) {
    getKPIValuesV6(
      dimensionType: $dimensionType
      dimensionTimeframe: $dimensionTimeframe
      dimensionValue: $dimensionValue
      nextToken: $nextToken
      limit: $limit
      sortColumn: $sortColumn
      sortOrder: $sortOrder
      circleLevelID: $circleLevelID
      circleID: $circleID
      parentCircleID: $parentCircleID
      viewID: $viewID
    )
  }
`;
export const getBracketActuals = /* GraphQL */ `
  query GetBracketActuals($missionID: ID!) {
    getBracketActuals(missionID: $missionID)
  }
`;
export const getDealHistory = /* GraphQL */ `
  query GetDealHistory($dealID: ID!) {
    getDealHistory(dealID: $dealID)
  }
`;
export const getDashboard = /* GraphQL */ `
  query GetDashboard($dashboardID: ID) {
    getDashboard(dashboardID: $dashboardID)
  }
`;
export const addPoints = /* GraphQL */ `
  query AddPoints($points: Float) {
    addPoints(points: $points) {
      id
      userID
      roleID
      orgID
      status
      memberType
      orgPoints
      lifetimeOrgPoints
      isActive
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        companyLogo
        coverPhoto
        legalBusinessName
        dbaName
        legalEntityType
        einTaxId
        statesOfOperation
        insuranceContactName
        insuranceContactTitle
        insuranceContactPhone
        insuranceContactEmail
        licenseNumber
        licenseIssuingState
        licenseExpirationDate
        bypassBillingCheck
        defaultEstimateDisclaimer
        standardScopeNotes
        planType
        clonedFrom
        billingType
        paymentCustomerID
        salesChannel
        selfServiceCancellation
        __typename
      }
      __typename
    }
  }
`;
export const listAreas = /* GraphQL */ `
  query ListAreas($showCompleted: Boolean!, $size: Int, $searchAfter: String) {
    listAreas(
      showCompleted: $showCompleted
      size: $size
      searchAfter: $searchAfter
    )
  }
`;
export const askRecorder = /* GraphQL */ `
  query AskRecorder($request: AWSJSON) {
    askRecorder(request: $request)
  }
`;
export const getPEOnboardingStatus = /* GraphQL */ `
  query GetPEOnboardingStatus($request: AWSJSON!) {
    getPEOnboardingStatus(request: $request)
  }
`;
export const getAppointmentGrid = /* GraphQL */ `
  query GetAppointmentGrid($request: AWSJSON!) {
    getAppointmentGrid(request: $request)
  }
`;
export const getUserLocations = /* GraphQL */ `
  query GetUserLocations(
    $latitude: Float!
    $longitude: Float!
    $latitudeDelta: Float!
    $longitudeDelta: Float!
    $timeframe: String!
    $principals: String!
  ) {
    getUserLocations(
      latitude: $latitude
      longitude: $longitude
      latitudeDelta: $latitudeDelta
      longitudeDelta: $longitudeDelta
      timeframe: $timeframe
      principals: $principals
    )
  }
`;
export const getEstimatesByDealId = /* GraphQL */ `
  query GetEstimatesByDealId($dealId: String!) {
    getEstimatesByDealId(dealId: $dealId)
  }
`;
export const getEstimate = /* GraphQL */ `
  query GetEstimate($estimateId: ID!) {
    getEstimate(estimateId: $estimateId)
  }
`;
export const getEstimateOrdersByDeal = /* GraphQL */ `
  query GetEstimateOrdersByDeal($request: AWSJSON!) {
    getEstimateOrdersByDeal(request: $request)
  }
`;
export const getClaimsByDealId = /* GraphQL */ `
  query GetClaimsByDealId($dealId: String!) {
    getClaimsByDealId(dealId: $dealId)
  }
`;
export const getClaim = /* GraphQL */ `
  query GetClaim($claimId: ID!) {
    getClaim(claimId: $claimId)
  }
`;
export const getClaimOrderByDeal = /* GraphQL */ `
  query GetClaimOrderByDeal($request: AWSJSON!) {
    getClaimOrderByDeal(request: $request)
  }
`;
export const getMeasurementOrderByDeal = /* GraphQL */ `
  query GetMeasurementOrderByDeal($request: AWSJSON!) {
    getMeasurementOrderByDeal(request: $request)
  }
`;
export const getOrgTemplates = /* GraphQL */ `
  query GetOrgTemplates($request: AWSJSON!) {
    getOrgTemplates(request: $request)
  }
`;
export const getPublishedOrgTemplates = /* GraphQL */ `
  query GetPublishedOrgTemplates($request: AWSJSON!) {
    getPublishedOrgTemplates(request: $request)
  }
`;
export const getOrgFindingTypes = /* GraphQL */ `
  query GetOrgFindingTypes($request: AWSJSON!) {
    getOrgFindingTypes(request: $request)
  }
`;
export const getTemplateFindingTypes = /* GraphQL */ `
  query GetTemplateFindingTypes($request: AWSJSON!) {
    getTemplateFindingTypes(request: $request)
  }
`;
export const getOrgZones = /* GraphQL */ `
  query GetOrgZones($request: AWSJSON!) {
    getOrgZones(request: $request)
  }
`;
export const getAITraining = /* GraphQL */ `
  query GetAITraining($id: ID!) {
    getAITraining(id: $id) {
      id
      orgID
      service
      name
      description
      prompt
      revision
      status
      users
      public
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listAITrainings = /* GraphQL */ `
  query ListAITrainings(
    $filter: ModelAITrainingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAITrainings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        service
        name
        description
        prompt
        revision
        status
        users
        public
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMessageThrottle = /* GraphQL */ `
  query GetMessageThrottle($id: ID!) {
    getMessageThrottle(id: $id) {
      id
      lastReceivedTmst
      lastSentTmst
      throttledMessage
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMessageThrottles = /* GraphQL */ `
  query ListMessageThrottles(
    $filter: ModelMessageThrottleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessageThrottles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lastReceivedTmst
        lastSentTmst
        throttledMessage
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCircleLevel = /* GraphQL */ `
  query GetCircleLevel($id: ID!) {
    getCircleLevel(id: $id) {
      id
      name
      description
      levelNum
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circles {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listCircleLevels = /* GraphQL */ `
  query ListCircleLevels(
    $filter: ModelCircleLevelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCircleLevels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        levelNum
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLeadArea = /* GraphQL */ `
  query GetLeadArea($id: ID!) {
    getLeadArea(id: $id) {
      id
      orgID
      name
      location {
        lat
        lon
        __typename
      }
      purchaseDate
      quantityOfLeads
      remainingLeads
      minimumPurchaseQuantity
      perLeadPrice
      daysToExpire
      initialPurchaseQuantity
      initialPurchasePrice
      totalCost
      pricePerLead
      leads {
        nextToken
        __typename
      }
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      transactions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listLeadAreas = /* GraphQL */ `
  query ListLeadAreas(
    $filter: ModelLeadAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeadAreas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLead = /* GraphQL */ `
  query GetLead($id: ID!) {
    getLead(id: $id) {
      id
      leadAreaID
      leadArea {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      orgID
      product
      whenPurchased
      assignedUserIDs
      assignedDate
      addressID
      dealID
      leadFlexFields
      status
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      address {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        estimatedAreaCreditRating
        medianHomeValue
        homeSquareFootage
        homeBuiltYear
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listLeads = /* GraphQL */ `
  query ListLeads(
    $filter: ModelLeadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeads(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        leadAreaID
        orgID
        product
        whenPurchased
        assignedUserIDs
        assignedDate
        addressID
        dealID
        leadFlexFields
        status
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIntegration = /* GraphQL */ `
  query GetIntegration($id: ID!) {
    getIntegration(id: $id) {
      id
      partner
      orgID
      partnerCode
      refreshToken
      accessToken
      expiration
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listIntegrations = /* GraphQL */ `
  query ListIntegrations(
    $filter: ModelIntegrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntegrations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        partner
        orgID
        partnerCode
        refreshToken
        accessToken
        expiration
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIntegrationXref = /* GraphQL */ `
  query GetIntegrationXref($id: ID!) {
    getIntegrationXref(id: $id) {
      id
      orgID
      partnerID
      partnerKeyName
      partnerKeyValue
      ourKeyName
      ourKeyValue
      mappingJSON
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listIntegrationXrefs = /* GraphQL */ `
  query ListIntegrationXrefs(
    $filter: ModelIntegrationXrefFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntegrationXrefs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        partnerID
        partnerKeyName
        partnerKeyValue
        ourKeyName
        ourKeyValue
        mappingJSON
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCircleLevelByOrg = /* GraphQL */ `
  query ListCircleLevelByOrg(
    $orgID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCircleLevelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCircleLevelByOrg(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        levelNum
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLeadAreasByOrg = /* GraphQL */ `
  query ListLeadAreasByOrg(
    $orgID: ID
    $purchaseDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLeadAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeadAreasByOrg(
      orgID: $orgID
      purchaseDate: $purchaseDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLeadAreasByPurchaseDate = /* GraphQL */ `
  query ListLeadAreasByPurchaseDate(
    $purchaseDate: AWSDateTime
    $sortDirection: ModelSortDirection
    $filter: ModelLeadAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeadAreasByPurchaseDate(
      purchaseDate: $purchaseDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLeadsByArea = /* GraphQL */ `
  query ListLeadsByArea(
    $leadAreaID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLeadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeadsByArea(
      leadAreaID: $leadAreaID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        leadAreaID
        orgID
        product
        whenPurchased
        assignedUserIDs
        assignedDate
        addressID
        dealID
        leadFlexFields
        status
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLeadsByOrg = /* GraphQL */ `
  query ListLeadsByOrg(
    $orgID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLeadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeadsByOrg(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        leadAreaID
        orgID
        product
        whenPurchased
        assignedUserIDs
        assignedDate
        addressID
        dealID
        leadFlexFields
        status
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLeadsByAddress = /* GraphQL */ `
  query ListLeadsByAddress(
    $addressID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLeadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeadsByAddress(
      addressID: $addressID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        leadAreaID
        orgID
        product
        whenPurchased
        assignedUserIDs
        assignedDate
        addressID
        dealID
        leadFlexFields
        status
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLeadsByDeal = /* GraphQL */ `
  query ListLeadsByDeal(
    $dealID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLeadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeadsByDeal(
      dealID: $dealID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        leadAreaID
        orgID
        product
        whenPurchased
        assignedUserIDs
        assignedDate
        addressID
        dealID
        leadFlexFields
        status
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReviewRequest = /* GraphQL */ `
  query GetReviewRequest($id: ID!) {
    getReviewRequest(id: $id) {
      id
      dealID
      orgID
      email
      phone
      message
      imageKeys
      expiresAt
      currentStatus
      createdBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listReviewRequests = /* GraphQL */ `
  query ListReviewRequests(
    $filter: ModelReviewRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReviewRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        dealID
        orgID
        email
        phone
        message
        imageKeys
        expiresAt
        currentStatus
        createdBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIntegrationConfig = /* GraphQL */ `
  query GetIntegrationConfig($id: ID!) {
    getIntegrationConfig(id: $id) {
      id
      integrationKey
      orgID
      crmName
      categoryID
      stageMapping
      fieldMapping
      configOptions
      isActive
      apiKey
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listIntegrationConfigs = /* GraphQL */ `
  query ListIntegrationConfigs(
    $filter: ModelIntegrationConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntegrationConfigs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        integrationKey
        orgID
        crmName
        categoryID
        stageMapping
        fieldMapping
        configOptions
        isActive
        apiKey
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listIntegrationConfigByOrgID = /* GraphQL */ `
  query ListIntegrationConfigByOrgID(
    $orgID: String
    $sortDirection: ModelSortDirection
    $filter: ModelIntegrationConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntegrationConfigByOrgID(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        integrationKey
        orgID
        crmName
        categoryID
        stageMapping
        fieldMapping
        configOptions
        isActive
        apiKey
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listIntegrationConfigIntegrationKey = /* GraphQL */ `
  query ListIntegrationConfigIntegrationKey(
    $integrationKey: ID
    $sortDirection: ModelSortDirection
    $filter: ModelIntegrationConfigFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntegrationConfigIntegrationKey(
      integrationKey: $integrationKey
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        integrationKey
        orgID
        crmName
        categoryID
        stageMapping
        fieldMapping
        configOptions
        isActive
        apiKey
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInboxEvent = /* GraphQL */ `
  query GetInboxEvent($id: ID!) {
    getInboxEvent(id: $id) {
      id
      orgID
      flexAttributes
      dealID
      sharedMediaID
      eventType
      status
      createdBy
      ownerID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      createdByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      owner {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listInboxEvents = /* GraphQL */ `
  query ListInboxEvents(
    $filter: ModelInboxEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInboxEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        flexAttributes
        dealID
        sharedMediaID
        eventType
        status
        createdBy
        ownerID
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSMSConversation = /* GraphQL */ `
  query GetSMSConversation($id: ID!) {
    getSMSConversation(id: $id) {
      id
      recipientNumber
      senderId
      reportID
      orgID
      contactID
      isDeleted
      createdAt
      updatedAt
      contact {
        id
        orgID
        companyID
        relatedContactID
        relationshipType
        firstName
        lastName
        phoneNumber
        email
        currentOwnerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listSMSConversations = /* GraphQL */ `
  query ListSMSConversations(
    $filter: ModelSMSConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSMSConversations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recipientNumber
        senderId
        reportID
        orgID
        contactID
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSharedMedia = /* GraphQL */ `
  query GetSharedMedia($id: ID!) {
    getSharedMedia(id: $id) {
      id
      orgID
      userID
      sharedBy
      dealID
      taskID
      mediaID
      sourceType
      sourceId
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      sharedByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listSharedMedias = /* GraphQL */ `
  query ListSharedMedias(
    $filter: ModelSharedMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSharedMedias(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        userID
        sharedBy
        dealID
        taskID
        mediaID
        sourceType
        sourceId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSelfRegisteredUser = /* GraphQL */ `
  query GetSelfRegisteredUser($id: ID!) {
    getSelfRegisteredUser(id: $id) {
      id
      email
      firstName
      lastName
      phoneNumber
      companyName
      companySize
      website
      orgID
      goals
      createdAt
      updatedAt
      invitees {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listSelfRegisteredUsers = /* GraphQL */ `
  query ListSelfRegisteredUsers(
    $filter: ModelSelfRegisteredUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSelfRegisteredUsers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        firstName
        lastName
        phoneNumber
        companyName
        companySize
        website
        orgID
        goals
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSelfRegisteredUserInvitee = /* GraphQL */ `
  query GetSelfRegisteredUserInvitee($id: ID!) {
    getSelfRegisteredUserInvitee(id: $id) {
      id
      orgID
      referredByID
      contactInformation
      shortCode
      invitationTimestamps
      createdAt
      createdBy
      updatedAt
      lastUpdatedBy
      referredBy {
        id
        email
        firstName
        lastName
        phoneNumber
        companyName
        companySize
        website
        orgID
        goals
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listSelfRegisteredUserInvitees = /* GraphQL */ `
  query ListSelfRegisteredUserInvitees(
    $filter: ModelSelfRegisteredUserInviteeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSelfRegisteredUserInvitees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        referredByID
        contactInformation
        shortCode
        invitationTimestamps
        createdAt
        createdBy
        updatedAt
        lastUpdatedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAIRequest = /* GraphQL */ `
  query GetAIRequest($id: ID!) {
    getAIRequest(id: $id) {
      id
      orgID
      service
      request
      response
      isError
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listAIRequests = /* GraphQL */ `
  query ListAIRequests(
    $filter: ModelAIRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAIRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        service
        request
        response
        isError
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserFeedback = /* GraphQL */ `
  query GetUserFeedback($id: ID!) {
    getUserFeedback(id: $id) {
      id
      userID
      orgID
      wasHelpful
      sourceType
      sourceId
      reasonTag
      userFeedback
      context
      reviewedByPaiv
      reviewedAt
      reviewedBy
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listUserFeedbacks = /* GraphQL */ `
  query ListUserFeedbacks(
    $filter: ModelUserFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserFeedbacks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        orgID
        wasHelpful
        sourceType
        sourceId
        reasonTag
        userFeedback
        context
        reviewedByPaiv
        reviewedAt
        reviewedBy
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIntakeConversation = /* GraphQL */ `
  query GetIntakeConversation($id: ID!) {
    getIntakeConversation(id: $id) {
      id
      orgID
      dealID
      sessionID
      userID
      taskListID
      role
      text
      displayText
      eventType
      questions
      actionButtons
      document
      selectedAnswerIDs
      selectedAnswersMap
      questionPhotoAttachments
      pressedActionButtonIDs
      toolCalls
      sortOrder
      turnIndex
      errorCode
      errorMessage
      tokenUsage
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listIntakeConversations = /* GraphQL */ `
  query ListIntakeConversations(
    $filter: ModelIntakeConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntakeConversations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        sessionID
        userID
        taskListID
        role
        text
        displayText
        eventType
        questions
        actionButtons
        document
        selectedAnswerIDs
        selectedAnswersMap
        questionPhotoAttachments
        pressedActionButtonIDs
        toolCalls
        sortOrder
        turnIndex
        errorCode
        errorMessage
        tokenUsage
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listIntakeConversationByDealID = /* GraphQL */ `
  query ListIntakeConversationByDealID(
    $dealID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelIntakeConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntakeConversationByDealID(
      dealID: $dealID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        sessionID
        userID
        taskListID
        role
        text
        displayText
        eventType
        questions
        actionButtons
        document
        selectedAnswerIDs
        selectedAnswersMap
        questionPhotoAttachments
        pressedActionButtonIDs
        toolCalls
        sortOrder
        turnIndex
        errorCode
        errorMessage
        tokenUsage
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listIntakeConversationBySessionID = /* GraphQL */ `
  query ListIntakeConversationBySessionID(
    $sessionID: String
    $sortOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelIntakeConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntakeConversationBySessionID(
      sessionID: $sessionID
      sortOrder: $sortOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        sessionID
        userID
        taskListID
        role
        text
        displayText
        eventType
        questions
        actionButtons
        document
        selectedAnswerIDs
        selectedAnswersMap
        questionPhotoAttachments
        pressedActionButtonIDs
        toolCalls
        sortOrder
        turnIndex
        errorCode
        errorMessage
        tokenUsage
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listIntakeConversationByOrgID = /* GraphQL */ `
  query ListIntakeConversationByOrgID(
    $orgID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelIntakeConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntakeConversationByOrgID(
      orgID: $orgID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        sessionID
        userID
        taskListID
        role
        text
        displayText
        eventType
        questions
        actionButtons
        document
        selectedAnswerIDs
        selectedAnswersMap
        questionPhotoAttachments
        pressedActionButtonIDs
        toolCalls
        sortOrder
        turnIndex
        errorCode
        errorMessage
        tokenUsage
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listIntakeConversationByTaskListID = /* GraphQL */ `
  query ListIntakeConversationByTaskListID(
    $taskListID: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelIntakeConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntakeConversationByTaskListID(
      taskListID: $taskListID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        sessionID
        userID
        taskListID
        role
        text
        displayText
        eventType
        questions
        actionButtons
        document
        selectedAnswerIDs
        selectedAnswersMap
        questionPhotoAttachments
        pressedActionButtonIDs
        toolCalls
        sortOrder
        turnIndex
        errorCode
        errorMessage
        tokenUsage
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEstimateOrder = /* GraphQL */ `
  query GetEstimateOrder($id: ID!) {
    getEstimateOrder(id: $id) {
      id
      dealID
      orgID
      userID
      dealName
      dealAddress
      status
      amount
      currency
      stripeCustomerID
      stripeUsageRecordID
      stripePaymentIntentID
      pdfUrl
      dealFileId
      source
      statusReason
      orderedAt
      readyAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEstimateOrders = /* GraphQL */ `
  query ListEstimateOrders(
    $filter: ModelEstimateOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEstimateOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        dealID
        orgID
        userID
        dealName
        dealAddress
        status
        amount
        currency
        stripeCustomerID
        stripeUsageRecordID
        stripePaymentIntentID
        pdfUrl
        dealFileId
        source
        statusReason
        orderedAt
        readyAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getClaimOrder = /* GraphQL */ `
  query GetClaimOrder($id: ID!) {
    getClaimOrder(id: $id) {
      id
      dealID
      orgID
      userID
      dealName
      dealAddress
      status
      pdfUrl
      orderedAt
      readyAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listClaimOrders = /* GraphQL */ `
  query ListClaimOrders(
    $filter: ModelClaimOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClaimOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        dealID
        orgID
        userID
        dealName
        dealAddress
        status
        pdfUrl
        orderedAt
        readyAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMeasurementReportOrder = /* GraphQL */ `
  query GetMeasurementReportOrder($id: ID!) {
    getMeasurementReportOrder(id: $id) {
      id
      dealID
      orgID
      userID
      status
      pdfUrl
      dealFileId
      statusReason
      reportProvider
      reportJSON
      orderedAt
      readyAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMeasurementReportOrders = /* GraphQL */ `
  query ListMeasurementReportOrders(
    $filter: ModelMeasurementReportOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMeasurementReportOrders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dealID
        orgID
        userID
        status
        pdfUrl
        dealFileId
        statusReason
        reportProvider
        reportJSON
        orderedAt
        readyAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFRRoute = /* GraphQL */ `
  query GetFRRoute($id: ID!) {
    getFRRoute(id: $id) {
      id
      orgID
      routeID
      officeID
      title
      templateID
      dateAdded
      addedBy
      groupID
      groupTitle
      date
      dayNotes
      dayAlert
      dayID
      additionalTechs
      assignedTech
      assignedTechPaivID
      apiCanSchedule
      scheduleTeams
      scheduleTypes
      averageLatitude
      averageLongitude
      averageDistance
      dateUpdated
      distanceScore
      estimatedAppointmentsDurationMinutes
      estimatedDrivingDurationSeconds
      capacityEstimateValue
      lockedRoute
      totalDistance
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFRRoutes = /* GraphQL */ `
  query ListFRRoutes(
    $filter: ModelFRRouteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFRRoutes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        routeID
        officeID
        title
        templateID
        dateAdded
        addedBy
        groupID
        groupTitle
        date
        dayNotes
        dayAlert
        dayID
        additionalTechs
        assignedTech
        assignedTechPaivID
        apiCanSchedule
        scheduleTeams
        scheduleTypes
        averageLatitude
        averageLongitude
        averageDistance
        dateUpdated
        distanceScore
        estimatedAppointmentsDurationMinutes
        estimatedDrivingDurationSeconds
        capacityEstimateValue
        lockedRoute
        totalDistance
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFRSpot = /* GraphQL */ `
  query GetFRSpot($id: ID!) {
    getFRSpot(id: $id) {
      id
      orgID
      paivRouteID
      assignedTechPaivID
      startTime
      endTime
      spotID
      officeID
      routeID
      date
      start
      end
      spotCapacity
      description
      blockReason
      currentAppointment
      assignedTech
      distanceToPrevious
      previousLat
      previousLng
      prevCustomer
      prevSpotID
      prevAppointmentID
      apiCanSchedule
      open
      lastUpdated
      dateUpdated
      distanceToNext
      nextLat
      nextLng
      nextCustomer
      nextSpotID
      nextAppointmentID
      reserved
      reservationEnd
      appointmentIDs
      customerIDs
      currentAppointmentDuration
      subscriptionID
      distanceToClosest
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFRSpots = /* GraphQL */ `
  query ListFRSpots(
    $filter: ModelFRSpotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFRSpots(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        paivRouteID
        assignedTechPaivID
        startTime
        endTime
        spotID
        officeID
        routeID
        date
        start
        end
        spotCapacity
        description
        blockReason
        currentAppointment
        assignedTech
        distanceToPrevious
        previousLat
        previousLng
        prevCustomer
        prevSpotID
        prevAppointmentID
        apiCanSchedule
        open
        lastUpdated
        dateUpdated
        distanceToNext
        nextLat
        nextLng
        nextCustomer
        nextSpotID
        nextAppointmentID
        reserved
        reservationEnd
        appointmentIDs
        customerIDs
        currentAppointmentDuration
        subscriptionID
        distanceToClosest
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFieldRoutesSpot = /* GraphQL */ `
  query GetFieldRoutesSpot($id: ID!) {
    getFieldRoutesSpot(id: $id) {
      id
      orgID
      spotID
      officeID
      routeID
      date
      start
      end
      spotCapacity
      description
      blockReason
      currentAppointment
      assignedTech
      distanceToPrevious
      previousLat
      previousLng
      prevCustomer
      prevSpotID
      prevAppointmentID
      apiCanSchedule
      open
      lastUpdated
      dateUpdated
      distanceToNext
      nextLat
      nextLng
      nextCustomer
      nextSpotID
      nextAppointmentID
      reserved
      reservationEnd
      appointmentIDs
      customerIDs
      currentAppointmentDuration
      subscriptionID
      distanceToClosest
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFieldRoutesSpots = /* GraphQL */ `
  query ListFieldRoutesSpots(
    $filter: ModelFieldRoutesSpotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFieldRoutesSpots(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        spotID
        officeID
        routeID
        date
        start
        end
        spotCapacity
        description
        blockReason
        currentAppointment
        assignedTech
        distanceToPrevious
        previousLat
        previousLng
        prevCustomer
        prevSpotID
        prevAppointmentID
        apiCanSchedule
        open
        lastUpdated
        dateUpdated
        distanceToNext
        nextLat
        nextLng
        nextCustomer
        nextSpotID
        nextAppointmentID
        reserved
        reservationEnd
        appointmentIDs
        customerIDs
        currentAppointmentDuration
        subscriptionID
        distanceToClosest
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFormTemplate = /* GraphQL */ `
  query GetFormTemplate($id: ID!) {
    getFormTemplate(id: $id) {
      id
      orgID
      officeID
      productIDs
      name
      description
      template
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listFormTemplates = /* GraphQL */ `
  query ListFormTemplates(
    $filter: ModelFormTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFormTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        officeID
        productIDs
        name
        description
        template
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTemplateByOrgIDOfficeID = /* GraphQL */ `
  query ListTemplateByOrgIDOfficeID(
    $orgID: ID
    $officeID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFormTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTemplateByOrgIDOfficeID(
      orgID: $orgID
      officeID: $officeID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        officeID
        productIDs
        name
        description
        template
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTemplatesByOrgIDName = /* GraphQL */ `
  query ListTemplatesByOrgIDName(
    $orgID: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFormTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTemplatesByOrgIDName(
      orgID: $orgID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        officeID
        productIDs
        name
        description
        template
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDocTemplate = /* GraphQL */ `
  query GetDocTemplate($id: ID!) {
    getDocTemplate(id: $id) {
      id
      orgID
      scope
      category
      name
      icon
      description
      basePrompt
      outputContract
      supportedStyles
      defaultStyle
      requiredDealData
      sortOrder
      enabled
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDocTemplates = /* GraphQL */ `
  query ListDocTemplates(
    $filter: ModelDocTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        scope
        category
        name
        icon
        description
        basePrompt
        outputContract
        supportedStyles
        defaultStyle
        requiredDealData
        sortOrder
        enabled
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDocTemplatesByOrgID = /* GraphQL */ `
  query ListDocTemplatesByOrgID(
    $orgID: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDocTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocTemplatesByOrgID(
      orgID: $orgID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        scope
        category
        name
        icon
        description
        basePrompt
        outputContract
        supportedStyles
        defaultStyle
        requiredDealData
        sortOrder
        enabled
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDocTemplatesByCategory = /* GraphQL */ `
  query ListDocTemplatesByCategory(
    $category: String
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDocTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocTemplatesByCategory(
      category: $category
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        scope
        category
        name
        icon
        description
        basePrompt
        outputContract
        supportedStyles
        defaultStyle
        requiredDealData
        sortOrder
        enabled
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      orgID
      categoryID
      extID
      name
      description
      frequency
      isSubscription
      omitFromPaiv
      reservice
      officeID
      defaultCharge
      defaultLength
      defaultContractLength
      contractLengthOptions
      defaultInitialCharge
      minRecurringCharge
      minInitialCharge
      regularService
      initialService
      seasonStart
      seasonEnd
      defaultFollowupDelay
      flexAttributes
      pests
      additionalPests
      bundledProducts
      productCode
      productFamily
      listPrice
      startDate
      endDate
      units
      status
      isDeleted
      isAppVisible
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      orderLines {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        categoryID
        extID
        name
        description
        frequency
        isSubscription
        omitFromPaiv
        reservice
        officeID
        defaultCharge
        defaultLength
        defaultContractLength
        contractLengthOptions
        defaultInitialCharge
        minRecurringCharge
        minInitialCharge
        regularService
        initialService
        seasonStart
        seasonEnd
        defaultFollowupDelay
        flexAttributes
        pests
        additionalPests
        bundledProducts
        productCode
        productFamily
        listPrice
        startDate
        endDate
        units
        status
        isDeleted
        isAppVisible
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProductByCategoryID = /* GraphQL */ `
  query ListProductByCategoryID(
    $categoryID: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductByCategoryID(
      categoryID: $categoryID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        extID
        name
        description
        frequency
        isSubscription
        omitFromPaiv
        reservice
        officeID
        defaultCharge
        defaultLength
        defaultContractLength
        contractLengthOptions
        defaultInitialCharge
        minRecurringCharge
        minInitialCharge
        regularService
        initialService
        seasonStart
        seasonEnd
        defaultFollowupDelay
        flexAttributes
        pests
        additionalPests
        bundledProducts
        productCode
        productFamily
        listPrice
        startDate
        endDate
        units
        status
        isDeleted
        isAppVisible
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProductByOrgID = /* GraphQL */ `
  query ListProductByOrgID(
    $orgID: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductByOrgID(
      orgID: $orgID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        extID
        name
        description
        frequency
        isSubscription
        omitFromPaiv
        reservice
        officeID
        defaultCharge
        defaultLength
        defaultContractLength
        contractLengthOptions
        defaultInitialCharge
        minRecurringCharge
        minInitialCharge
        regularService
        initialService
        seasonStart
        seasonEnd
        defaultFollowupDelay
        flexAttributes
        pests
        additionalPests
        bundledProducts
        productCode
        productFamily
        listPrice
        startDate
        endDate
        units
        status
        isDeleted
        isAppVisible
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      orgID
      dealID
      extID
      discountAmount
      dateSold
      isPaidInFull
      isDeleted
      orderLinesOrder
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      orderLines {
        nextToken
        __typename
      }
      payments {
        nextToken
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        dealID
        extID
        discountAmount
        dateSold
        isPaidInFull
        isDeleted
        orderLinesOrder
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrdersByDealID = /* GraphQL */ `
  query ListOrdersByDealID(
    $dealID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersByDealID(
      dealID: $dealID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        extID
        discountAmount
        dateSold
        isPaidInFull
        isDeleted
        orderLinesOrder
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrderLine = /* GraphQL */ `
  query GetOrderLine($id: ID!) {
    getOrderLine(id: $id) {
      id
      orgID
      productID
      orderID
      extID
      isSubscription
      frequencyDays
      initialDelayDays
      name
      description
      quantity
      unitPrice
      currencyCode
      discountPercent
      discountAmount
      dateSold
      status
      isInitialService
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      product {
        id
        orgID
        categoryID
        extID
        name
        description
        frequency
        isSubscription
        omitFromPaiv
        reservice
        officeID
        defaultCharge
        defaultLength
        defaultContractLength
        contractLengthOptions
        defaultInitialCharge
        minRecurringCharge
        minInitialCharge
        regularService
        initialService
        seasonStart
        seasonEnd
        defaultFollowupDelay
        flexAttributes
        pests
        additionalPests
        bundledProducts
        productCode
        productFamily
        listPrice
        startDate
        endDate
        units
        status
        isDeleted
        isAppVisible
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      order {
        id
        orgID
        dealID
        extID
        discountAmount
        dateSold
        isPaidInFull
        isDeleted
        orderLinesOrder
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listOrderLines = /* GraphQL */ `
  query ListOrderLines(
    $filter: ModelOrderLineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderLines(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        productID
        orderID
        extID
        isSubscription
        frequencyDays
        initialDelayDays
        name
        description
        quantity
        unitPrice
        currencyCode
        discountPercent
        discountAmount
        dateSold
        status
        isInitialService
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrdersProductID = /* GraphQL */ `
  query ListOrdersProductID(
    $productID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOrderLineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrdersProductID(
      productID: $productID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        productID
        orderID
        extID
        isSubscription
        frequencyDays
        initialDelayDays
        name
        description
        quantity
        unitPrice
        currencyCode
        discountPercent
        discountAmount
        dateSold
        status
        isInitialService
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrderLinesByOrderID = /* GraphQL */ `
  query ListOrderLinesByOrderID(
    $orderID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOrderLineFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderLinesByOrderID(
      orderID: $orderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        productID
        orderID
        extID
        isSubscription
        frequencyDays
        initialDelayDays
        name
        description
        quantity
        unitPrice
        currencyCode
        discountPercent
        discountAmount
        dateSold
        status
        isInitialService
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLesson = /* GraphQL */ `
  query GetLesson($id: ID!) {
    getLesson(id: $id) {
      id
      orgID
      name
      description
      isDeleted
      startDate
      endDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      details {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listLessons = /* GraphQL */ `
  query ListLessons(
    $filter: ModelLessonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        name
        description
        isDeleted
        startDate
        endDate
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLessonDetail = /* GraphQL */ `
  query GetLessonDetail($id: ID!) {
    getLessonDetail(id: $id) {
      id
      lessonID
      orgID
      name
      description
      category
      order
      imageType
      imageName
      posterImageName
      url
      urlType
      youTubeURL
      flexFields
      startDate
      endDate
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      lesson {
        id
        orgID
        name
        description
        isDeleted
        startDate
        endDate
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      assignments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listLessonDetails = /* GraphQL */ `
  query ListLessonDetails(
    $filter: ModelLessonDetailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        lessonID
        orgID
        name
        description
        category
        order
        imageType
        imageName
        posterImageName
        url
        urlType
        youTubeURL
        flexFields
        startDate
        endDate
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLessonDetailByCategoryOrder = /* GraphQL */ `
  query ListLessonDetailByCategoryOrder(
    $orgID: ID
    $categoryOrder: ModelLessonDetailByOrgCategoryOrderCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLessonDetailFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonDetailByCategoryOrder(
      orgID: $orgID
      categoryOrder: $categoryOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonID
        orgID
        name
        description
        category
        order
        imageType
        imageName
        posterImageName
        url
        urlType
        youTubeURL
        flexFields
        startDate
        endDate
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLessonAssignment = /* GraphQL */ `
  query GetLessonAssignment($id: ID!) {
    getLessonAssignment(id: $id) {
      id
      lessonDetailID
      orgID
      assignedToID
      assignedToType
      flexAttributes
      startedTmst
      completedTmst
      percentComplete
      isStarted
      isComplete
      isDeleted
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      lessonDetail {
        id
        lessonID
        orgID
        name
        description
        category
        order
        imageType
        imageName
        posterImageName
        url
        urlType
        youTubeURL
        flexFields
        startDate
        endDate
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listLessonAssignments = /* GraphQL */ `
  query ListLessonAssignments(
    $filter: ModelLessonAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLessonAssignments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lessonDetailID
        orgID
        assignedToID
        assignedToType
        flexAttributes
        startedTmst
        completedTmst
        percentComplete
        isStarted
        isComplete
        isDeleted
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDealPaymentTokens = /* GraphQL */ `
  query GetDealPaymentTokens($id: ID!) {
    getDealPaymentTokens(id: $id) {
      id
      orgID
      dealID
      isDeleted
      type
      address_zip
      brand
      exp_month
      exp_year
      transaction_id
      last_4
      name
      routing_number
      token
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDealPaymentTokenss = /* GraphQL */ `
  query ListDealPaymentTokenss(
    $filter: ModeldealPaymentTokensFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealPaymentTokenss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        isDeleted
        type
        address_zip
        brand
        exp_month
        exp_year
        transaction_id
        last_4
        name
        routing_number
        token
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealPaymentTokensByDealID = /* GraphQL */ `
  query ListDealPaymentTokensByDealID(
    $dealID: ID
    $sortDirection: ModelSortDirection
    $filter: ModeldealPaymentTokensFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealPaymentTokensByDealID(
      dealID: $dealID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        isDeleted
        type
        address_zip
        brand
        exp_month
        exp_year
        transaction_id
        last_4
        name
        routing_number
        token
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealPaymentTokensByOrgID = /* GraphQL */ `
  query ListDealPaymentTokensByOrgID(
    $orgID: ID
    $sortDirection: ModelSortDirection
    $filter: ModeldealPaymentTokensFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealPaymentTokensByOrgID(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        isDeleted
        type
        address_zip
        brand
        exp_month
        exp_year
        transaction_id
        last_4
        name
        routing_number
        token
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDealPayment = /* GraphQL */ `
  query GetDealPayment($id: ID!) {
    getDealPayment(id: $id) {
      id
      orgID
      dealID
      orderID
      type
      transactionAmount
      transactionID
      cardToken
      description
      currencyCode
      responseJSON
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDealPayments = /* GraphQL */ `
  query ListDealPayments(
    $filter: ModeldealPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        dealID
        orderID
        type
        transactionAmount
        transactionID
        cardToken
        description
        currencyCode
        responseJSON
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealPaymentByDealID = /* GraphQL */ `
  query ListDealPaymentByDealID(
    $dealID: ID
    $sortDirection: ModelSortDirection
    $filter: ModeldealPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealPaymentByDealID(
      dealID: $dealID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        orderID
        type
        transactionAmount
        transactionID
        cardToken
        description
        currencyCode
        responseJSON
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealPaymentByOrderID = /* GraphQL */ `
  query ListDealPaymentByOrderID(
    $orderID: ID
    $sortDirection: ModelSortDirection
    $filter: ModeldealPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealPaymentByOrderID(
      orderID: $orderID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        orderID
        type
        transactionAmount
        transactionID
        cardToken
        description
        currencyCode
        responseJSON
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealPaymentByOrgID = /* GraphQL */ `
  query ListDealPaymentByOrgID(
    $orgID: ID
    $sortDirection: ModelSortDirection
    $filter: ModeldealPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealPaymentByOrgID(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        orderID
        type
        transactionAmount
        transactionID
        cardToken
        description
        currencyCode
        responseJSON
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealPaymentByTransactionID = /* GraphQL */ `
  query ListDealPaymentByTransactionID(
    $transactionID: String
    $sortDirection: ModelSortDirection
    $filter: ModeldealPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealPaymentByTransactionID(
      transactionID: $transactionID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        orderID
        type
        transactionAmount
        transactionID
        cardToken
        description
        currencyCode
        responseJSON
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPersonDefaultSchedule = /* GraphQL */ `
  query GetPersonDefaultSchedule($id: ID!) {
    getPersonDefaultSchedule(id: $id) {
      id
      orgID
      userID
      circleIDs
      officeID
      days
      startDate
      endDate
      startTime
      endTime
      minimumMeetingLength
      maximumMeetingLength
      defaultMeetingLength
      minutesBetweenMeetings
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPersonDefaultSchedules = /* GraphQL */ `
  query ListPersonDefaultSchedules(
    $filter: ModelPersonDefaultScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonDefaultSchedules(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        circleIDs
        officeID
        days
        startDate
        endDate
        startTime
        endTime
        minimumMeetingLength
        maximumMeetingLength
        defaultMeetingLength
        minutesBetweenMeetings
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPersonDefaultScheduleByUser = /* GraphQL */ `
  query ListPersonDefaultScheduleByUser(
    $userID: ID
    $startDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPersonDefaultScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonDefaultScheduleByUser(
      userID: $userID
      startDate: $startDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        circleIDs
        officeID
        days
        startDate
        endDate
        startTime
        endTime
        minimumMeetingLength
        maximumMeetingLength
        defaultMeetingLength
        minutesBetweenMeetings
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPersonScheduleOverride = /* GraphQL */ `
  query GetPersonScheduleOverride($id: ID!) {
    getPersonScheduleOverride(id: $id) {
      id
      orgID
      userID
      date
      startTime
      endTime
      minimumMeetingLength
      maximumMeetingLength
      defaultMeetingLength
      minutesBetweenMeetings
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPersonScheduleOverrides = /* GraphQL */ `
  query ListPersonScheduleOverrides(
    $filter: ModelPersonScheduleOverrideFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonScheduleOverrides(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        date
        startTime
        endTime
        minimumMeetingLength
        maximumMeetingLength
        defaultMeetingLength
        minutesBetweenMeetings
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPersonScheduleOverrideByUser = /* GraphQL */ `
  query ListPersonScheduleOverrideByUser(
    $userID: ID
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPersonScheduleOverrideFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonScheduleOverrideByUser(
      userID: $userID
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        date
        startTime
        endTime
        minimumMeetingLength
        maximumMeetingLength
        defaultMeetingLength
        minutesBetweenMeetings
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSpot = /* GraphQL */ `
  query GetSpot($id: ID!) {
    getSpot(id: $id) {
      id
      orgID
      userID
      officeID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listSpots = /* GraphQL */ `
  query ListSpots(
    $filter: ModelSpotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSpots(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        userID
        officeID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPersonAppointment = /* GraphQL */ `
  query GetPersonAppointment($id: ID!) {
    getPersonAppointment(id: $id) {
      id
      orgID
      userID
      setterID
      extID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      notes
      status
      statusSetterRole
      dealID
      officeID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      history {
        nextToken
        __typename
      }
      address {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        estimatedAreaCreditRating
        medianHomeValue
        homeSquareFootage
        homeBuiltYear
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      setter {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listPersonAppointments = /* GraphQL */ `
  query ListPersonAppointments(
    $filter: ModelPersonAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonAppointments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        setterID
        extID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        notes
        status
        statusSetterRole
        dealID
        officeID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAppointmentByUser = /* GraphQL */ `
  query ListAppointmentByUser(
    $userID: ID
    $appointmentDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPersonAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppointmentByUser(
      userID: $userID
      appointmentDate: $appointmentDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        setterID
        extID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        notes
        status
        statusSetterRole
        dealID
        officeID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAppointmentBySetter = /* GraphQL */ `
  query ListAppointmentBySetter(
    $setterID: ID
    $appointmentDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPersonAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppointmentBySetter(
      setterID: $setterID
      appointmentDate: $appointmentDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        setterID
        extID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        notes
        status
        statusSetterRole
        dealID
        officeID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAppointmentByDeal = /* GraphQL */ `
  query ListAppointmentByDeal(
    $dealID: ID
    $appointmentDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPersonAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppointmentByDeal(
      dealID: $dealID
      appointmentDate: $appointmentDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        setterID
        extID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        notes
        status
        statusSetterRole
        dealID
        officeID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAppointmentByUpdatedAt = /* GraphQL */ `
  query ListAppointmentByUpdatedAt(
    $orgID: ID
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPersonAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAppointmentByUpdatedAt(
      orgID: $orgID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        setterID
        extID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        notes
        status
        statusSetterRole
        dealID
        officeID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPersonAppointmentHistory = /* GraphQL */ `
  query GetPersonAppointmentHistory($id: ID!) {
    getPersonAppointmentHistory(id: $id) {
      id
      personAppointmentID
      orgID
      userID
      setterID
      changerID
      appointmentDate
      appointmentStartTime
      appointmentEndTime
      notes
      status
      statusSetterRole
      dealID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      setter {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      changeUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listPersonAppointmentHistorys = /* GraphQL */ `
  query ListPersonAppointmentHistorys(
    $filter: ModelPersonAppointmentHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonAppointmentHistorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        personAppointmentID
        orgID
        userID
        setterID
        changerID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        notes
        status
        statusSetterRole
        dealID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPersonAppointmentHistoryByID = /* GraphQL */ `
  query ListPersonAppointmentHistoryByID(
    $userID: ID
    $personAppointmentID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPersonAppointmentHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonAppointmentHistoryByID(
      userID: $userID
      personAppointmentID: $personAppointmentID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        personAppointmentID
        orgID
        userID
        setterID
        changerID
        appointmentDate
        appointmentStartTime
        appointmentEndTime
        notes
        status
        statusSetterRole
        dealID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCalendar = /* GraphQL */ `
  query GetCalendar($id: ID!) {
    getCalendar(id: $id) {
      id
      orgID
      scheduleDate
      areaID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      slots {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listCalendars = /* GraphQL */ `
  query ListCalendars(
    $filter: ModelCalendarFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCalendars(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        scheduleDate
        areaID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCalendarSlot = /* GraphQL */ `
  query GetCalendarSlot($id: ID!) {
    getCalendarSlot(id: $id) {
      id
      orgID
      calendarID
      startTime
      endTime
      available
      scheduled
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      appointments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listCalendarSlots = /* GraphQL */ `
  query ListCalendarSlots(
    $filter: ModelCalendarSlotFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCalendarSlots(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        calendarID
        startTime
        endTime
        available
        scheduled
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCalendarAppointment = /* GraphQL */ `
  query GetCalendarAppointment($id: ID!) {
    getCalendarAppointment(id: $id) {
      id
      orgID
      slotID
      dealID
      notes
      status
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      slot {
        id
        orgID
        calendarID
        startTime
        endTime
        available
        scheduled
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listCalendarAppointments = /* GraphQL */ `
  query ListCalendarAppointments(
    $filter: ModelCalendarAppointmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCalendarAppointments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        slotID
        dealID
        notes
        status
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserAddress = /* GraphQL */ `
  query GetUserAddress($id: ID!) {
    getUserAddress(id: $id) {
      id
      userID
      orgID
      type
      address1
      address2
      city
      region
      country
      postalCode
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listUserAddresss = /* GraphQL */ `
  query ListUserAddresss(
    $filter: ModelUserAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserAddresss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        orgID
        type
        address1
        address2
        city
        region
        country
        postalCode
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPindropLog = /* GraphQL */ `
  query GetPindropLog($id: ID!) {
    getPindropLog(id: $id) {
      id
      orgID
      addressID
      createdBy
      createdAt
      dispositionID
      isDeleted
      appVersionCode
      deviceType
      officeID
      updatedAt
      __typename
    }
  }
`;
export const listPindropLogs = /* GraphQL */ `
  query ListPindropLogs(
    $filter: ModelPindropLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPindropLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        addressID
        createdBy
        createdAt
        dispositionID
        isDeleted
        appVersionCode
        deviceType
        officeID
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAddress = /* GraphQL */ `
  query GetAddress($id: ID!) {
    getAddress(id: $id) {
      id
      customerID
      doorDataID
      categoryID
      orgID
      isMultiUnit
      parentAddressID
      street
      address
      unitNumber
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      distanceFromDoor
      lastVisited
      nextVisit
      currentOwnerID
      lastVisitedByID
      lastVisitedByName
      currentDispositionID
      status
      officeID
      flexAttributes
      name
      creditEstimate
      maritalStatus
      renterFlag
      age
      income
      lengthOfResidence
      estimatedAreaCreditRating
      medianHomeValue
      homeSquareFootage
      homeBuiltYear
      expireAt
      expireAtEpoch
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      isHidden
      tags {
        nextToken
        __typename
      }
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listAddresss = /* GraphQL */ `
  query ListAddresss(
    $filter: ModelAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddresss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        estimatedAreaCreditRating
        medianHomeValue
        homeSquareFootage
        homeBuiltYear
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAddressByAddress = /* GraphQL */ `
  query ListAddressByAddress(
    $city: String
    $postalCodeStreetAddress: ModelAddressByAddressCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddressByAddress(
      city: $city
      postalCodeStreetAddress: $postalCodeStreetAddress
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        estimatedAreaCreditRating
        medianHomeValue
        homeSquareFootage
        homeBuiltYear
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAddressByUpdatedAt = /* GraphQL */ `
  query ListAddressByUpdatedAt(
    $orgID: ID
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddressByUpdatedAt(
      orgID: $orgID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        estimatedAreaCreditRating
        medianHomeValue
        homeSquareFootage
        homeBuiltYear
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAddressByAddressPostalcode = /* GraphQL */ `
  query ListAddressByAddressPostalcode(
    $address: String
    $postalCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddressByAddressPostalcode(
      address: $address
      postalCode: $postalCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        estimatedAreaCreditRating
        medianHomeValue
        homeSquareFootage
        homeBuiltYear
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAddressByDoorDataID = /* GraphQL */ `
  query ListAddressByDoorDataID(
    $doorDataID: ID
    $orgID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAddressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddressByDoorDataID(
      doorDataID: $doorDataID
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        estimatedAreaCreditRating
        medianHomeValue
        homeSquareFootage
        homeBuiltYear
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchAddresss = /* GraphQL */ `
  query SearchAddresss(
    $filter: SearchableAddressFilterInput
    $sort: SearchableAddressSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchAddresss(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        estimatedAreaCreditRating
        medianHomeValue
        homeSquareFootage
        homeBuiltYear
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getInaccurateAddressCoordinates = /* GraphQL */ `
  query GetInaccurateAddressCoordinates($id: ID!) {
    getInaccurateAddressCoordinates(id: $id) {
      id
      orgID
      createdAt
      updatedAt
      address
      city
      region
      country
      postalCode
      location {
        lat
        lon
        __typename
      }
      geoCodeMatchLevel
      doorDataID
      distanceFromDoor
      actualPinCoordinates {
        lat
        lon
        __typename
      }
      lastUpdatedBy
      doorCreatedAt
      doorUpdatedAt
      __typename
    }
  }
`;
export const listInaccurateAddressCoordinatess = /* GraphQL */ `
  query ListInaccurateAddressCoordinatess(
    $filter: ModelInaccurateAddressCoordinatesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInaccurateAddressCoordinatess(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        createdAt
        updatedAt
        address
        city
        region
        country
        postalCode
        geoCodeMatchLevel
        doorDataID
        distanceFromDoor
        lastUpdatedBy
        doorCreatedAt
        doorUpdatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGeoFence = /* GraphQL */ `
  query GetGeoFence($id: ID!) {
    getGeoFence(id: $id) {
      id
      orgID
      points {
        lat
        lon
        __typename
      }
      assigneeID
      assigneeIDs
      assigneeType
      currentUserID
      status
      name
      description
      possibleAddresses
      knockedAddresses
      tags
      colorCode
      flexAttributes
      lastVisited
      scheduledDate
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      assignees {
        nextToken
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      currentUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listGeoFences = /* GraphQL */ `
  query ListGeoFences(
    $filter: ModelgeoFenceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGeoFences(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        assigneeID
        assigneeIDs
        assigneeType
        currentUserID
        status
        name
        description
        possibleAddresses
        knockedAddresses
        tags
        colorCode
        flexAttributes
        lastVisited
        scheduledDate
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listGeoFenceByOrgID = /* GraphQL */ `
  query ListGeoFenceByOrgID(
    $orgID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelgeoFenceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGeoFenceByOrgID(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        assigneeID
        assigneeIDs
        assigneeType
        currentUserID
        status
        name
        description
        possibleAddresses
        knockedAddresses
        tags
        colorCode
        flexAttributes
        lastVisited
        scheduledDate
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getGeoFenceAssignee = /* GraphQL */ `
  query GetGeoFenceAssignee($id: ID!) {
    getGeoFenceAssignee(id: $id) {
      id
      orgID
      geofenceID
      assigneeID
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listGeoFenceAssignees = /* GraphQL */ `
  query ListGeoFenceAssignees(
    $filter: ModelGeoFenceAssigneeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGeoFenceAssignees(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        geofenceID
        assigneeID
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listGeoFenceAssigneeByGeofenceID = /* GraphQL */ `
  query ListGeoFenceAssigneeByGeofenceID(
    $geofenceID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelGeoFenceAssigneeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGeoFenceAssigneeByGeofenceID(
      geofenceID: $geofenceID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        geofenceID
        assigneeID
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      orgID
      categoryID
      addressID
      extID
      parentCustomerID
      firstName
      lastName
      phone {
        phoneType
        number
        __typename
      }
      email
      address1
      address2
      city
      region
      postalCode
      country
      location {
        lat
        lon
        __typename
      }
      customerType
      leadSource
      flexAttributes
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        categoryID
        addressID
        extID
        parentCustomerID
        firstName
        lastName
        email
        address1
        address2
        city
        region
        postalCode
        country
        customerType
        leadSource
        flexAttributes
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTag = /* GraphQL */ `
  query GetTag($id: ID!) {
    getTag(id: $id) {
      id
      orgID
      name
      color
      icon
      isGlobal
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listTags = /* GraphQL */ `
  query ListTags(
    $filter: ModelTagFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTags(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        name
        color
        icon
        isGlobal
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTagAssignment = /* GraphQL */ `
  query GetTagAssignment($id: ID!) {
    getTagAssignment(id: $id) {
      id
      orgID
      taggedObjectID
      tagID
      taggedObjectType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      tag {
        id
        orgID
        name
        color
        icon
        isGlobal
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listTagAssignments = /* GraphQL */ `
  query ListTagAssignments(
    $filter: ModelTagAssignmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTagAssignments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        taggedObjectID
        tagID
        taggedObjectType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDeal = /* GraphQL */ `
  query GetDeal($id: ID!) {
    getDeal(id: $id) {
      id
      orgID
      categoryID
      isContract
      customerID
      dealTypeID
      extID
      name
      sortName
      description
      searchString
      ownersString
      officeID
      value
      notes
      status
      currentStageID
      currentOwnerID
      defaultCircleID
      currentOwnerType
      currentDispositionID
      nextFollowupDate
      reminderSentTmst
      flexAttributes
      previousFlexAttributes
      lastInspectionType
      lastInspectionTmst
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      paymentTokens {
        nextToken
        __typename
      }
      DealAppointments {
        nextToken
        __typename
      }
      appointments {
        nextToken
        __typename
      }
      pinAddress {
        id
        customerID
        doorDataID
        categoryID
        orgID
        isMultiUnit
        parentAddressID
        street
        address
        unitNumber
        city
        region
        country
        postalCode
        distanceFromDoor
        lastVisited
        nextVisit
        currentOwnerID
        lastVisitedByID
        lastVisitedByName
        currentDispositionID
        status
        officeID
        flexAttributes
        name
        creditEstimate
        maritalStatus
        renterFlag
        age
        income
        lengthOfResidence
        estimatedAreaCreditRating
        medianHomeValue
        homeSquareFootage
        homeBuiltYear
        expireAt
        expireAtEpoch
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isHidden
        __typename
      }
      tags {
        nextToken
        __typename
      }
      transactions {
        nextToken
        __typename
      }
      ownerHistory {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      files {
        nextToken
        __typename
      }
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        isInspectionStage
        requireCloser
        sendToCRM
        isReadOnly
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      actions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listDeals = /* GraphQL */ `
  query ListDeals(
    $filter: ModelDealFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDeals(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const DealByCategoryStatus = /* GraphQL */ `
  query DealByCategoryStatus(
    $categoryID: ID
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDealFilterInput
    $limit: Int
    $nextToken: String
  ) {
    DealByCategoryStatus(
      categoryID: $categoryID
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const DealByOwnerStage = /* GraphQL */ `
  query DealByOwnerStage(
    $currentOwnerID: ID
    $currentStageID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDealFilterInput
    $limit: Int
    $nextToken: String
  ) {
    DealByOwnerStage(
      currentOwnerID: $currentOwnerID
      currentStageID: $currentStageID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDealTransactions = /* GraphQL */ `
  query GetDealTransactions($id: ID!) {
    getDealTransactions(id: $id) {
      id
      dealID
      orgID
      flexAttributes
      currentDispositionID
      currentOwnerID
      currentStageID
      officeID
      isReversal
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      isNewDeal
      queuedForRulesEngine
      actualTimestamp
      source
      rulesEngineStartTime
      rulesEngineEndTime
      ErrorMessage
      __typename
    }
  }
`;
export const listDealTransactionss = /* GraphQL */ `
  query ListDealTransactionss(
    $filter: ModelDealTransactionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealTransactionss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dealID
        orgID
        flexAttributes
        currentDispositionID
        currentOwnerID
        currentStageID
        officeID
        isReversal
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isNewDeal
        queuedForRulesEngine
        actualTimestamp
        source
        rulesEngineStartTime
        rulesEngineEndTime
        ErrorMessage
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDealStageHistory = /* GraphQL */ `
  query GetDealStageHistory($id: ID!) {
    getDealStageHistory(id: $id) {
      id
      dealID
      stageID
      rulesEngineProcessed
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listDealStageHistorys = /* GraphQL */ `
  query ListDealStageHistorys(
    $filter: ModelDealStageHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealStageHistorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dealID
        stageID
        rulesEngineProcessed
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDealOwnerHistory = /* GraphQL */ `
  query GetDealOwnerHistory($id: ID!) {
    getDealOwnerHistory(id: $id) {
      id
      dealID
      orgID
      userID
      ownerType
      isActive
      percent
      isCalculateKPIs
      isMissionCredit
      notes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listDealOwnerHistorys = /* GraphQL */ `
  query ListDealOwnerHistorys(
    $filter: ModelDealOwnerHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealOwnerHistorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dealID
        orgID
        userID
        ownerType
        isActive
        percent
        isCalculateKPIs
        isMissionCredit
        notes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealOwnerHistoryByDealID = /* GraphQL */ `
  query ListDealOwnerHistoryByDealID(
    $dealID: ID
    $userID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDealOwnerHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealOwnerHistoryByDealID(
      dealID: $dealID
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dealID
        orgID
        userID
        ownerType
        isActive
        percent
        isCalculateKPIs
        isMissionCredit
        notes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDealComments = /* GraphQL */ `
  query GetDealComments($id: ID!) {
    getDealComments(id: $id) {
      id
      orgID
      dealID
      type
      comment
      timestampedComment
      summary
      actionItems
      audioDisplayName
      transcriber
      AAITranscriptID
      audioName
      audioLength
      audioType
      dispositionID
      followupDate
      contactType
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listDealCommentss = /* GraphQL */ `
  query ListDealCommentss(
    $filter: ModelDealCommentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealCommentss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        dealID
        type
        comment
        timestampedComment
        summary
        actionItems
        audioDisplayName
        transcriber
        AAITranscriptID
        audioName
        audioLength
        audioType
        dispositionID
        followupDate
        contactType
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealCommentsByDeal = /* GraphQL */ `
  query ListDealCommentsByDeal(
    $dealID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelDealCommentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealCommentsByDeal(
      dealID: $dealID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        type
        comment
        timestampedComment
        summary
        actionItems
        audioDisplayName
        transcriber
        AAITranscriptID
        audioName
        audioLength
        audioType
        dispositionID
        followupDate
        contactType
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealCommentsByOrgID = /* GraphQL */ `
  query ListDealCommentsByOrgID(
    $orgID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDealCommentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealCommentsByOrgID(
      orgID: $orgID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        type
        comment
        timestampedComment
        summary
        actionItems
        audioDisplayName
        transcriber
        AAITranscriptID
        audioName
        audioLength
        audioType
        dispositionID
        followupDate
        contactType
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealCommentsByCreatedBy = /* GraphQL */ `
  query ListDealCommentsByCreatedBy(
    $createdBy: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDealCommentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealCommentsByCreatedBy(
      createdBy: $createdBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        type
        comment
        timestampedComment
        summary
        actionItems
        audioDisplayName
        transcriber
        AAITranscriptID
        audioName
        audioLength
        audioType
        dispositionID
        followupDate
        contactType
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRecordingComments = /* GraphQL */ `
  query GetRecordingComments($id: ID!) {
    getRecordingComments(id: $id) {
      id
      orgID
      recordingID
      comment
      timestamp
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      recording {
        id
        orgID
        dealID
        type
        comment
        timestampedComment
        summary
        actionItems
        audioDisplayName
        transcriber
        AAITranscriptID
        audioName
        audioLength
        audioType
        dispositionID
        followupDate
        contactType
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listRecordingCommentss = /* GraphQL */ `
  query ListRecordingCommentss(
    $filter: ModelRecordingCommentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecordingCommentss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        recordingID
        comment
        timestamp
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRecordingCommentsByRecording = /* GraphQL */ `
  query ListRecordingCommentsByRecording(
    $recordingID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecordingCommentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecordingCommentsByRecording(
      recordingID: $recordingID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        recordingID
        comment
        timestamp
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRecordingCommentsByOrgID = /* GraphQL */ `
  query ListRecordingCommentsByOrgID(
    $orgID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecordingCommentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecordingCommentsByOrgID(
      orgID: $orgID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        recordingID
        comment
        timestamp
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRecordingCommentsByCreatedBy = /* GraphQL */ `
  query ListRecordingCommentsByCreatedBy(
    $createdBy: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecordingCommentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecordingCommentsByCreatedBy(
      createdBy: $createdBy
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        recordingID
        comment
        timestamp
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDealClaim = /* GraphQL */ `
  query GetDealClaim($id: ID!) {
    getDealClaim(id: $id) {
      id
      orgID
      dealID
      taskListID
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listDealClaims = /* GraphQL */ `
  query ListDealClaims(
    $filter: ModelDealClaimFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealClaims(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        dealID
        taskListID
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDealFile = /* GraphQL */ `
  query GetDealFile($id: ID!) {
    getDealFile(id: $id) {
      id
      orgID
      dealID
      reportID
      reportType
      source
      orderID
      task_id
      deal_id
      description
      tags
      category
      locationText
      location {
        lat
        lon
        __typename
      }
      type
      url
      sequence
      createdBy
      lastUpdatedBy
      fileTimestampEpoch
      createdAt
      updatedAt
      isDeleted
      comments {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listDealFiles = /* GraphQL */ `
  query ListDealFiles(
    $filter: ModelDealFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        dealID
        reportID
        reportType
        source
        orderID
        task_id
        deal_id
        description
        tags
        category
        locationText
        type
        url
        sequence
        createdBy
        lastUpdatedBy
        fileTimestampEpoch
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealFilesByDealIDType = /* GraphQL */ `
  query ListDealFilesByDealIDType(
    $dealID: ID
    $type: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDealFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealFilesByDealIDType(
      dealID: $dealID
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        reportID
        reportType
        source
        orderID
        task_id
        deal_id
        description
        tags
        category
        locationText
        type
        url
        sequence
        createdBy
        lastUpdatedBy
        fileTimestampEpoch
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealFilesByDealIDReportType = /* GraphQL */ `
  query ListDealFilesByDealIDReportType(
    $dealID: ID
    $reportType: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDealFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealFilesByDealIDReportType(
      dealID: $dealID
      reportType: $reportType
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        reportID
        reportType
        source
        orderID
        task_id
        deal_id
        description
        tags
        category
        locationText
        type
        url
        sequence
        createdBy
        lastUpdatedBy
        fileTimestampEpoch
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealFilesByReportID = /* GraphQL */ `
  query ListDealFilesByReportID(
    $reportID: ID
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDealFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealFilesByReportID(
      reportID: $reportID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        reportID
        reportType
        source
        orderID
        task_id
        deal_id
        description
        tags
        category
        locationText
        type
        url
        sequence
        createdBy
        lastUpdatedBy
        fileTimestampEpoch
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDealFileComment = /* GraphQL */ `
  query GetDealFileComment($id: ID!) {
    getDealFileComment(id: $id) {
      id
      orgID
      reportID
      isInternalOnly
      comment
      name
      contactInformation
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listDealFileComments = /* GraphQL */ `
  query ListDealFileComments(
    $filter: ModelDealFileCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealFileComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        reportID
        isInternalOnly
        comment
        name
        contactInformation
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealCommentByReportID = /* GraphQL */ `
  query ListDealCommentByReportID(
    $reportID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDealFileCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealCommentByReportID(
      reportID: $reportID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        reportID
        isInternalOnly
        comment
        name
        contactInformation
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReportEditContext = /* GraphQL */ `
  query GetReportEditContext($id: ID!) {
    getReportEditContext(id: $id) {
      id
      reportID
      dealID
      orgID
      thread {
        turnId
        role
        text
        ops
        resultingVersion
        status
        createdAt
        __typename
      }
      directives {
        id
        type
        text
        scope
        active
        createdBy
        createdAt
        __typename
      }
      lastEditedBy
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listReportEditContexts = /* GraphQL */ `
  query ListReportEditContexts(
    $filter: ModelReportEditContextFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReportEditContexts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportID
        dealID
        orgID
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listReportEditContextByReportID = /* GraphQL */ `
  query ListReportEditContextByReportID(
    $reportID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelReportEditContextFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReportEditContextByReportID(
      reportID: $reportID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportID
        dealID
        orgID
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listReportEditContextByDealID = /* GraphQL */ `
  query ListReportEditContextByDealID(
    $dealID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelReportEditContextFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReportEditContextByDealID(
      dealID: $dealID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reportID
        dealID
        orgID
        lastEditedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDealType = /* GraphQL */ `
  query GetDealType($id: ID!) {
    getDealType(id: $id) {
      id
      orgID
      title
      formID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listDealTypes = /* GraphQL */ `
  query ListDealTypes(
    $filter: ModelDealTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        title
        formID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDealTypeByOrgID = /* GraphQL */ `
  query ListDealTypeByOrgID(
    $orgID: ID
    $title: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDealTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDealTypeByOrgID(
      orgID: $orgID
      title: $title
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        title
        formID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getForm = /* GraphQL */ `
  query GetForm($id: ID!) {
    getForm(id: $id) {
      id
      orgID
      title
      flexAttributes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listForms = /* GraphQL */ `
  query ListForms(
    $filter: ModelFormFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listForms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        title
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listFormByOrgID = /* GraphQL */ `
  query ListFormByOrgID(
    $orgID: ID
    $title: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFormFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFormByOrgID(
      orgID: $orgID
      title: $title
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        title
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStage = /* GraphQL */ `
  query GetStage($id: ID!) {
    getStage(id: $id) {
      id
      orgID
      title
      dealTypeID
      description
      userSelectable
      changeToDispositionID
      setStages
      clearStages
      reverseIDs
      action
      actionPastTense
      measure
      measurePlural
      valueUnit
      valueUnitPlural
      countUnit
      countUnitPlural
      iconName
      iconType
      iconColor
      flexAttributes
      sequence
      winProbability
      pinColor
      icon
      isMapDefault
      isDisplay
      isActive
      isNoDealDefault
      isInspectionStage
      requireCloser
      sendToCRM
      isReadOnly
      calendarAppointmentStatus
      categoryID
      imageName
      imageType
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listStages = /* GraphQL */ `
  query ListStages(
    $filter: ModelStageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        isInspectionStage
        requireCloser
        sendToCRM
        isReadOnly
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStageByOrgID = /* GraphQL */ `
  query ListStageByOrgID(
    $orgID: ID
    $title: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageByOrgID(
      orgID: $orgID
      title: $title
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        isInspectionStage
        requireCloser
        sendToCRM
        isReadOnly
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStageByCategorySequence = /* GraphQL */ `
  query ListStageByCategorySequence(
    $categoryID: ID
    $sequence: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageByCategorySequence(
      categoryID: $categoryID
      sequence: $sequence
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        isInspectionStage
        requireCloser
        sendToCRM
        isReadOnly
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStageByDealTypeID = /* GraphQL */ `
  query ListStageByDealTypeID(
    $categoryID: ID
    $sequence: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageByDealTypeID(
      categoryID: $categoryID
      sequence: $sequence
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        isInspectionStage
        requireCloser
        sendToCRM
        isReadOnly
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStageCategory = /* GraphQL */ `
  query GetStageCategory($id: ID!) {
    getStageCategory(id: $id) {
      id
      orgID
      title
      iconName
      iconType
      iconColor
      isDefault
      enablePindrop
      enableDeal
      defaultProductFamily
      flexAttributes
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      stages {
        nextToken
        __typename
      }
      history {
        nextToken
        __typename
      }
      dispositions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listStageCategorys = /* GraphQL */ `
  query ListStageCategorys(
    $filter: ModelStageCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStageCategoryByOrgID = /* GraphQL */ `
  query ListStageCategoryByOrgID(
    $orgID: ID
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStageCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageCategoryByOrgID(
      orgID: $orgID
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStageCategoryHistory = /* GraphQL */ `
  query GetStageCategoryHistory($id: ID!) {
    getStageCategoryHistory(id: $id) {
      id
      orgID
      categoryID
      createdAt
      object
      updatedAt
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listStageCategoryHistorys = /* GraphQL */ `
  query ListStageCategoryHistorys(
    $filter: ModelStageCategoryHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageCategoryHistorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        createdAt
        object
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStageCategoryHistoryByOrgID = /* GraphQL */ `
  query ListStageCategoryHistoryByOrgID(
    $orgID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStageCategoryHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageCategoryHistoryByOrgID(
      orgID: $orgID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        createdAt
        object
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStageCategoryHistoryByCategoryID = /* GraphQL */ `
  query ListStageCategoryHistoryByCategoryID(
    $categoryID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStageCategoryHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageCategoryHistoryByCategoryID(
      categoryID: $categoryID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        createdAt
        object
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStageDisposition = /* GraphQL */ `
  query GetStageDisposition($id: ID!) {
    getStageDisposition(id: $id) {
      id
      orgID
      categoryID
      title
      formName
      stageID
      isSetupDeal
      requireDate
      isDefault
      noRecording
      isConversation
      isNotSelectable
      isNonMapDefault
      deleteType
      groupID
      order
      expiresIn
      commentsAtTop
      iconName
      iconType
      iconColor
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listStageDispositions = /* GraphQL */ `
  query ListStageDispositions(
    $filter: ModelStageDispositionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageDispositions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStageDispositionByCategoryID = /* GraphQL */ `
  query ListStageDispositionByCategoryID(
    $categoryID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelStageDispositionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageDispositionByCategoryID(
      categoryID: $categoryID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStageDispositionByCategoryIDOrder = /* GraphQL */ `
  query ListStageDispositionByCategoryIDOrder(
    $categoryID: ID
    $order: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStageDispositionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageDispositionByCategoryIDOrder(
      categoryID: $categoryID
      order: $order
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listStageDispositionByOrgID = /* GraphQL */ `
  query ListStageDispositionByOrgID(
    $orgID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelStageDispositionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStageDispositionByOrgID(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMissionTrophy = /* GraphQL */ `
  query GetMissionTrophy($id: ID!) {
    getMissionTrophy(id: $id) {
      id
      orgID
      missionID
      title
      description
      imageName
      imageType
      place
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listMissionTrophys = /* GraphQL */ `
  query ListMissionTrophys(
    $filter: ModelMissionTrophyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMissionTrophys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        missionID
        title
        description
        imageName
        imageType
        place
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getKPIRule = /* GraphQL */ `
  query GetKPIRule($id: ID!) {
    getKPIRule(id: $id) {
      id
      orgID
      type
      timeframe
      title
      abbreviation
      sourceType
      formula
      triggerID
      dimensions
      action
      actionPastTense
      valueUnit
      valueUnitPlural
      categoryID
      viewerRoles
      leaderboardViewerRoles
      scorecardViewerRoles
      order
      editorRoles
      functionalRoles
      eventCreatorScope
      contactDispositionFilter
      entitlement
      isHidden
      useDateOfStage
      format
      roundPrecision
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      stage {
        id
        orgID
        title
        dealTypeID
        description
        userSelectable
        changeToDispositionID
        setStages
        clearStages
        reverseIDs
        action
        actionPastTense
        measure
        measurePlural
        valueUnit
        valueUnitPlural
        countUnit
        countUnitPlural
        iconName
        iconType
        iconColor
        flexAttributes
        sequence
        winProbability
        pinColor
        icon
        isMapDefault
        isDisplay
        isActive
        isNoDealDefault
        isInspectionStage
        requireCloser
        sendToCRM
        isReadOnly
        calendarAppointmentStatus
        categoryID
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        enablePindrop
        enableDeal
        defaultProductFamily
        flexAttributes
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      disposition {
        id
        orgID
        categoryID
        title
        formName
        stageID
        isSetupDeal
        requireDate
        isDefault
        noRecording
        isConversation
        isNotSelectable
        isNonMapDefault
        deleteType
        groupID
        order
        expiresIn
        commentsAtTop
        iconName
        iconType
        iconColor
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      aggs {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listKPIRules = /* GraphQL */ `
  query ListKPIRules(
    $filter: ModelKPIRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listKPIRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        contactDispositionFilter
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listKPIRulesByOrg = /* GraphQL */ `
  query ListKPIRulesByOrg(
    $orgID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelKPIRuleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listKPIRulesByOrg(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        contactDispositionFilter
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getKPIValueAggs = /* GraphQL */ `
  query GetKPIValueAggs($id: ID!) {
    getKPIValueAggs(id: $id) {
      id
      orgID
      userKey
      count
      sum
      val
      goal
      dimensionID
      KPIRuleID
      dimension
      currentPosition
      previousPosition
      mostRecentDimensionID
      leaderboard
      isDeleted
      createdAt
      updatedAt
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        contactDispositionFilter
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listKPIValueAggss = /* GraphQL */ `
  query ListKPIValueAggss(
    $filter: ModelKPIValueAggsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listKPIValueAggss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        userKey
        count
        sum
        val
        goal
        dimensionID
        KPIRuleID
        dimension
        currentPosition
        previousPosition
        mostRecentDimensionID
        leaderboard
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const KPIValueAggsByUserKey = /* GraphQL */ `
  query KPIValueAggsByUserKey(
    $userKey: ID
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelKPIValueAggsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    KPIValueAggsByUserKey(
      userKey: $userKey
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userKey
        count
        sum
        val
        goal
        dimensionID
        KPIRuleID
        dimension
        currentPosition
        previousPosition
        mostRecentDimensionID
        leaderboard
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getKPIValueAggsTransactions = /* GraphQL */ `
  query GetKPIValueAggsTransactions($id: ID!) {
    getKPIValueAggsTransactions(id: $id) {
      id
      KPIValueAggsID
      inputValue
      dealID
      dealTransactionsID
      orgID
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      dealTransaction {
        id
        dealID
        orgID
        flexAttributes
        currentDispositionID
        currentOwnerID
        currentStageID
        officeID
        isReversal
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        isNewDeal
        queuedForRulesEngine
        actualTimestamp
        source
        rulesEngineStartTime
        rulesEngineEndTime
        ErrorMessage
        __typename
      }
      KPIValueAgg {
        id
        orgID
        userKey
        count
        sum
        val
        goal
        dimensionID
        KPIRuleID
        dimension
        currentPosition
        previousPosition
        mostRecentDimensionID
        leaderboard
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listKPIValueAggsTransactionss = /* GraphQL */ `
  query ListKPIValueAggsTransactionss(
    $filter: ModelKPIValueAggsTransactionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listKPIValueAggsTransactionss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        KPIValueAggsID
        inputValue
        dealID
        dealTransactionsID
        orgID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPersonActivityFeed = /* GraphQL */ `
  query GetPersonActivityFeed($id: ID!) {
    getPersonActivityFeed(id: $id) {
      id
      userID
      isRead
      orgID
      type
      showAfter
      showAfterEpoch
      showUntilEpoch
      extID
      createdAt
      updatedAt
      isDeleted
      activityFeed {
        id
        event
        header
        details
        imageName
        imageType
        chartType
        chartData
        orgID
        type
        showAfterEpoch
        showUntilEpoch
        showAfter
        extID
        createdAt
        createdBy
        changedID
        updatedAt
        lastUpdatedBy
        isDeleted
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listPersonActivityFeeds = /* GraphQL */ `
  query ListPersonActivityFeeds(
    $filter: ModelPersonActivityFeedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonActivityFeeds(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        isRead
        orgID
        type
        showAfter
        showAfterEpoch
        showUntilEpoch
        extID
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const feedByDateNew = /* GraphQL */ `
  query FeedByDateNew(
    $userID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPersonActivityFeedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    feedByDateNew(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        isRead
        orgID
        type
        showAfter
        showAfterEpoch
        showUntilEpoch
        extID
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const feedByUpdatedAt = /* GraphQL */ `
  query FeedByUpdatedAt(
    $userID: ID
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPersonActivityFeedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    feedByUpdatedAt(
      userID: $userID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        isRead
        orgID
        type
        showAfter
        showAfterEpoch
        showUntilEpoch
        extID
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const feedByShowAfter = /* GraphQL */ `
  query FeedByShowAfter(
    $userID: ID
    $showAfter: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPersonActivityFeedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    feedByShowAfter(
      userID: $userID
      showAfter: $showAfter
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        isRead
        orgID
        type
        showAfter
        showAfterEpoch
        showUntilEpoch
        extID
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCircleActivityFeed = /* GraphQL */ `
  query GetCircleActivityFeed($id: ID!) {
    getCircleActivityFeed(id: $id) {
      id
      activityFeedID
      circleID
      orgID
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listCircleActivityFeeds = /* GraphQL */ `
  query ListCircleActivityFeeds(
    $filter: ModelCircleActivityFeedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCircleActivityFeeds(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        activityFeedID
        circleID
        orgID
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActivityFeed = /* GraphQL */ `
  query GetActivityFeed($id: ID!) {
    getActivityFeed(id: $id) {
      id
      event
      header
      details
      imageName
      imageType
      chartType
      chartData
      orgID
      type
      showAfterEpoch
      showUntilEpoch
      showAfter
      extID
      createdAt
      createdBy
      changedID
      updatedAt
      lastUpdatedBy
      isDeleted
      people {
        nextToken
        __typename
      }
      emoticons {
        nextToken
        __typename
      }
      changedEmoticon {
        id
        activityFeedID
        type
        userID
        orgID
        createdAt
        isDeleted
        updatedAt
        __typename
      }
      changedCommentEmoticon {
        id
        commentID
        type
        userID
        orgID
        createdAt
        isDeleted
        updatedAt
        __typename
      }
      comments {
        nextToken
        __typename
      }
      changedComment {
        id
        content
        userID
        imageName
        imageType
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      createdByUser {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listActivityFeeds = /* GraphQL */ `
  query ListActivityFeeds(
    $filter: ModelActivityFeedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivityFeeds(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        event
        header
        details
        imageName
        imageType
        chartType
        chartData
        orgID
        type
        showAfterEpoch
        showUntilEpoch
        showAfter
        extID
        createdAt
        createdBy
        changedID
        updatedAt
        lastUpdatedBy
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listActivityFeedByScheduleSendEpoch = /* GraphQL */ `
  query ListActivityFeedByScheduleSendEpoch(
    $orgID: ID
    $showAfterEpoch: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelActivityFeedFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivityFeedByScheduleSendEpoch(
      orgID: $orgID
      showAfterEpoch: $showAfterEpoch
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        event
        header
        details
        imageName
        imageType
        chartType
        chartData
        orgID
        type
        showAfterEpoch
        showUntilEpoch
        showAfter
        extID
        createdAt
        createdBy
        changedID
        updatedAt
        lastUpdatedBy
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActivityFeedEmoticon = /* GraphQL */ `
  query GetActivityFeedEmoticon($id: ID!) {
    getActivityFeedEmoticon(id: $id) {
      id
      activityFeedID
      type
      userID
      orgID
      createdAt
      isDeleted
      updatedAt
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listActivityFeedEmoticons = /* GraphQL */ `
  query ListActivityFeedEmoticons(
    $filter: ModelActivityFeedEmoticonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivityFeedEmoticons(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        activityFeedID
        type
        userID
        orgID
        createdAt
        isDeleted
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCommentEmoticon = /* GraphQL */ `
  query GetCommentEmoticon($id: ID!) {
    getCommentEmoticon(id: $id) {
      id
      commentID
      type
      userID
      orgID
      createdAt
      isDeleted
      updatedAt
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listCommentEmoticons = /* GraphQL */ `
  query ListCommentEmoticons(
    $filter: ModelCommentEmoticonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommentEmoticons(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        commentID
        type
        userID
        orgID
        createdAt
        isDeleted
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($id: ID!) {
    getComment(id: $id) {
      id
      content
      userID
      imageName
      imageType
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      activityFeed {
        id
        event
        header
        details
        imageName
        imageType
        chartType
        chartData
        orgID
        type
        showAfterEpoch
        showUntilEpoch
        showAfter
        extID
        createdAt
        createdBy
        changedID
        updatedAt
        lastUpdatedBy
        isDeleted
        __typename
      }
      emoticons {
        nextToken
        __typename
      }
      parentComment {
        id
        content
        userID
        imageName
        imageType
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      comments {
        nextToken
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        userID
        imageName
        imageType
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const commentByDate = /* GraphQL */ `
  query CommentByDate(
    $createdAt: AWSDateTime
    $sortDirection: ModelSortDirection
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    commentByDate(
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        userID
        imageName
        imageType
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMission = /* GraphQL */ `
  query GetMission($id: ID!) {
    getMission(id: $id) {
      id
      type
      contestType
      name
      description
      rewardLimit
      rewardCount
      rewardType
      actionPastTense
      actionTypePlural
      rewardID
      rewardName
      scope
      ownerID
      ownerType
      startDate
      endDate
      launchDate
      startDateEpoch
      endDateEpoch
      launchDateEpoch
      KPIRuleID
      tieKPIRuleID
      imageName
      imageType
      questType
      questOrder
      location
      actionCount
      action
      actionType
      minGoal
      actionCountType
      completePictureRequired
      isDeleted
      nextLaunchFeedBlast
      nextExpireFeedBlast
      tags
      rules {
        id
        multiplier
        name
        role
        goal
        sequence
        __typename
      }
      bracket
      orgID
      mostRecentUserID
      trophiesAwarded
      rewardsAwarded
      bracketWinner
      autoAssign
      assignToChildCircles
      autoCreateMonths
      permissions
      categoryID
      flexFields
      useStepCounter
      isCircleOnly
      isPublic
      rewardDisposition
      useAutoGoal
      autoGoalTimeframe
      autoGoalTimeframeCount
      autoGoalFactor
      minAutoGoal
      roundGoalPrecision
      advanceType
      nextMissionID
      topNumberAdvance
      useAutoCreate
      autoCreateTimeframe
      autoCreateTimeframeCount
      autoCreateStartDate
      autoCreateEndDate
      isHidden
      competitors
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        contactDispositionFilter
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      tieKPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        contactDispositionFilter
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      category {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        doNotShow
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      missions {
        nextToken
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        companyLogo
        coverPhoto
        legalBusinessName
        dbaName
        legalEntityType
        einTaxId
        statesOfOperation
        insuranceContactName
        insuranceContactTitle
        insuranceContactPhone
        insuranceContactEmail
        licenseNumber
        licenseIssuingState
        licenseExpirationDate
        bypassBillingCheck
        defaultEstimateDisclaimer
        standardScopeNotes
        planType
        clonedFrom
        billingType
        paymentCustomerID
        salesChannel
        selfServiceCancellation
        __typename
      }
      circles {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listMissions = /* GraphQL */ `
  query ListMissions(
    $filter: ModelMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const byEndDate = /* GraphQL */ `
  query ByEndDate(
    $endDate: AWSDateTime
    $sortDirection: ModelSortDirection
    $filter: ModelMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byEndDate(
      endDate: $endDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const KPIRuleID = /* GraphQL */ `
  query KPIRuleID(
    $KPIRuleID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    KPIRuleID(
      KPIRuleID: $KPIRuleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMissionByEndDate = /* GraphQL */ `
  query ListMissionByEndDate(
    $orgID: ID
    $endDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMissionByEndDate(
      orgID: $orgID
      endDate: $endDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMissionsByOrgStartDateEpoch = /* GraphQL */ `
  query ListMissionsByOrgStartDateEpoch(
    $orgID: ID
    $startDateEpoch: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMissionsByOrgStartDateEpoch(
      orgID: $orgID
      startDateEpoch: $startDateEpoch
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMissionsByOrgName = /* GraphQL */ `
  query ListMissionsByOrgName(
    $orgID: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMissionsByOrgName(
      orgID: $orgID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMissionCategory = /* GraphQL */ `
  query GetMissionCategory($id: ID!) {
    getMissionCategory(id: $id) {
      id
      orgID
      title
      iconName
      iconType
      iconColor
      isDefault
      doNotShow
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      missions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listMissionCategorys = /* GraphQL */ `
  query ListMissionCategorys(
    $filter: ModelMissionCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMissionCategorys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        title
        iconName
        iconType
        iconColor
        isDefault
        doNotShow
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMissionReward = /* GraphQL */ `
  query GetMissionReward($id: ID!) {
    getMissionReward(id: $id) {
      id
      orgID
      missionID
      rewardID
      points
      minActionCount
      place
      isTie
      awardedToIDs
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listMissionRewards = /* GraphQL */ `
  query ListMissionRewards(
    $filter: ModelMissionRewardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMissionRewards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        missionID
        rewardID
        points
        minActionCount
        place
        isTie
        awardedToIDs
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getQuestMission = /* GraphQL */ `
  query GetQuestMission($id: ID!) {
    getQuestMission(id: $id) {
      id
      questID
      missionID
      reservedByID
      reservationExpiration
      isComplete
      sequence
      permissions
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      quest {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listQuestMissions = /* GraphQL */ `
  query ListQuestMissions(
    $filter: ModelQuestMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestMissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        questID
        missionID
        reservedByID
        reservationExpiration
        isComplete
        sequence
        permissions
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listQuestMissionByMission = /* GraphQL */ `
  query ListQuestMissionByMission(
    $missionID: ID
    $questID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestMissionByMission(
      missionID: $missionID
      questID: $questID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        questID
        missionID
        reservedByID
        reservationExpiration
        isComplete
        sequence
        permissions
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listQuestMissionByQuest = /* GraphQL */ `
  query ListQuestMissionByQuest(
    $questID: ID
    $missionID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestMissionByQuest(
      questID: $questID
      missionID: $missionID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        questID
        missionID
        reservedByID
        reservationExpiration
        isComplete
        sequence
        permissions
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCircle = /* GraphQL */ `
  query GetCircle($id: ID!) {
    getCircle(id: $id) {
      id
      extID
      name
      sortName
      description
      location
      scope
      inviterType
      approverType
      status
      isActive
      isHidden
      imageName
      imageType
      avatarImageName
      communityID
      startDate
      endDate
      launchDate
      orgID
      nextLaunchFeedBlast
      nextExpireFeedBlast
      permissions
      parentCircleID
      levelID
      colorCode
      fieldRoutesOfficeID
      flexAttributes
      coordinates {
        lat
        lon
        __typename
      }
      tangoAccountID
      isLeague
      hasWanderMode
      hasRoundRobin
      defaultSchedulerID
      level {
        id
        name
        description
        levelNum
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      useRecordingConsent
      parent {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      children {
        nextToken
        __typename
      }
      preferences {
        nextToken
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        companyLogo
        coverPhoto
        legalBusinessName
        dbaName
        legalEntityType
        einTaxId
        statesOfOperation
        insuranceContactName
        insuranceContactTitle
        insuranceContactPhone
        insuranceContactEmail
        licenseNumber
        licenseIssuingState
        licenseExpirationDate
        bypassBillingCheck
        defaultEstimateDisclaimer
        standardScopeNotes
        planType
        clonedFrom
        billingType
        paymentCustomerID
        salesChannel
        selfServiceCancellation
        __typename
      }
      users {
        nextToken
        __typename
      }
      missions {
        nextToken
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listCircles = /* GraphQL */ `
  query ListCircles(
    $filter: ModelCircleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCircles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCirclesByOrg = /* GraphQL */ `
  query ListCirclesByOrg(
    $orgID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCircleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCirclesByOrg(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCirclesByParentCircleID = /* GraphQL */ `
  query ListCirclesByParentCircleID(
    $parentCircleID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCircleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCirclesByParentCircleID(
      parentCircleID: $parentCircleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCirclesByTangoAccountID = /* GraphQL */ `
  query ListCirclesByTangoAccountID(
    $tangoAccountID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelCircleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCirclesByTangoAccountID(
      tangoAccountID: $tangoAccountID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCircles = /* GraphQL */ `
  query SearchCircles(
    $filter: SearchableCircleFilterInput
    $sort: SearchableCircleSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchCircles(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      extID
      username
      email
      phoneNumber
      name
      birthdate
      imageName
      imageType
      location
      nameVisibility
      phoneNumberVisibility
      emailVisibility
      birthdateVisibility
      pictureVisibility
      locationVisibility
      initials
      pronoun
      role
      functionalRoles
      status
      expoToken
      orgID
      title
      externalTitle
      externalName
      externalEmail
      externalPhoneNumber
      externalBio
      socials {
        type
        uri
        __typename
      }
      categories
      avatarID
      levelID
      circleLevel {
        id
        name
        description
        levelNum
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      agreedToTerms
      agreedToTermsAt
      tags
      colorCode
      hasWanderMode
      hasRoundRobin
      flexAttributes
      defaultCategoryID
      allowedCategoryIDs
      stripeCustomerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      excludeFromBilling
      lessonAssignments {
        nextToken
        __typename
      }
      PersonDefaultSchedules {
        nextToken
        __typename
      }
      PersonScheduleOverrides {
        nextToken
        __typename
      }
      PersonAppointments {
        nextToken
        __typename
      }
      SetterAppointments {
        nextToken
        __typename
      }
      addresses {
        nextToken
        __typename
      }
      kpis {
        nextToken
        __typename
      }
      orgs {
        nextToken
        __typename
      }
      circles {
        nextToken
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUsersByOrg = /* GraphQL */ `
  query ListUsersByOrg(
    $orgID: ID
    $email: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsersByOrg(
      orgID: $orgID
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchUsers = /* GraphQL */ `
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: SearchableUserSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      orgID
      name
      phoneNumber
      website
      currentOwnerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      Contacts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listCompanys = /* GraphQL */ `
  query ListCompanys(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        name
        phoneNumber
        website
        currentOwnerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getContactList = /* GraphQL */ `
  query GetContactList($id: ID!) {
    getContactList(id: $id) {
      id
      orgID
      name
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      members {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listContactLists = /* GraphQL */ `
  query ListContactLists(
    $filter: ModelContactListFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactLists(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        name
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getContactMember = /* GraphQL */ `
  query GetContactMember($id: ID!) {
    getContactMember(id: $id) {
      id
      orgID
      contactListID
      contactID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      contactList {
        id
        orgID
        name
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      contact {
        id
        orgID
        companyID
        relatedContactID
        relationshipType
        firstName
        lastName
        phoneNumber
        email
        currentOwnerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listContactMembers = /* GraphQL */ `
  query ListContactMembers(
    $filter: ModelContactMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        contactListID
        contactID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getContact = /* GraphQL */ `
  query GetContact($id: ID!) {
    getContact(id: $id) {
      id
      orgID
      companyID
      relatedContactID
      relationshipType
      firstName
      lastName
      phoneNumber
      email
      currentOwnerID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      lists {
        nextToken
        __typename
      }
      RelatedContacts {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listContacts = /* GraphQL */ `
  query ListContacts(
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        companyID
        relatedContactID
        relationshipType
        firstName
        lastName
        phoneNumber
        email
        currentOwnerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPreferences = /* GraphQL */ `
  query GetPreferences($id: ID!) {
    getPreferences(id: $id) {
      id
      orgID
      isHidden
      preferenceType
      name
      entityType
      entityID
      preferences
      isDeleted
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPreferencess = /* GraphQL */ `
  query ListPreferencess(
    $filter: ModelPreferencesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPreferencess(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        isHidden
        preferenceType
        name
        entityType
        entityID
        preferences
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrgHistory = /* GraphQL */ `
  query GetOrgHistory($id: ID!) {
    getOrgHistory(id: $id) {
      id
      orgID
      createdAt
      object
      updatedAt
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        companyLogo
        coverPhoto
        legalBusinessName
        dbaName
        legalEntityType
        einTaxId
        statesOfOperation
        insuranceContactName
        insuranceContactTitle
        insuranceContactPhone
        insuranceContactEmail
        licenseNumber
        licenseIssuingState
        licenseExpirationDate
        bypassBillingCheck
        defaultEstimateDisclaimer
        standardScopeNotes
        planType
        clonedFrom
        billingType
        paymentCustomerID
        salesChannel
        selfServiceCancellation
        __typename
      }
      __typename
    }
  }
`;
export const listOrgHistorys = /* GraphQL */ `
  query ListOrgHistorys(
    $filter: ModelOrgHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrgHistorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        createdAt
        object
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrgHistoryByOrgID = /* GraphQL */ `
  query ListOrgHistoryByOrgID(
    $orgID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrgHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrgHistoryByOrgID(
      orgID: $orgID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        createdAt
        object
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrg = /* GraphQL */ `
  query GetOrg($id: ID!) {
    getOrg(id: $id) {
      id
      stripeID
      gamifyBundle
      name
      domains
      contactEmail
      contactName
      contactAddress
      contactAddress2
      contactCity
      contactState
      contactZip
      contactPhone
      configParms
      hubspotID
      countryCode
      integrations
      restrictionType
      permissions
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      docuSealAccess
      companyLogo
      coverPhoto
      legalBusinessName
      dbaName
      legalEntityType
      einTaxId
      statesOfOperation
      insuranceContactName
      insuranceContactTitle
      insuranceContactPhone
      insuranceContactEmail
      licenseNumber
      licenseIssuingState
      licenseExpirationDate
      trials {
        length
        startDate
        type
        __typename
      }
      bypassBillingCheck
      defaultEstimateDisclaimer
      standardScopeNotes
      planType
      clonedFrom
      billingType
      paymentCustomerID
      salesChannel
      selfServiceCancellation
      circles {
        nextToken
        __typename
      }
      preferences {
        nextToken
        __typename
      }
      history {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listOrgs = /* GraphQL */ `
  query ListOrgs(
    $filter: ModelOrgFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrgs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        companyLogo
        coverPhoto
        legalBusinessName
        dbaName
        legalEntityType
        einTaxId
        statesOfOperation
        insuranceContactName
        insuranceContactTitle
        insuranceContactPhone
        insuranceContactEmail
        licenseNumber
        licenseIssuingState
        licenseExpirationDate
        bypassBillingCheck
        defaultEstimateDisclaimer
        standardScopeNotes
        planType
        clonedFrom
        billingType
        paymentCustomerID
        salesChannel
        selfServiceCancellation
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrgMember = /* GraphQL */ `
  query GetOrgMember($id: ID!) {
    getOrgMember(id: $id) {
      id
      userID
      roleID
      orgID
      status
      memberType
      orgPoints
      lifetimeOrgPoints
      isActive
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      org {
        id
        stripeID
        gamifyBundle
        name
        domains
        contactEmail
        contactName
        contactAddress
        contactAddress2
        contactCity
        contactState
        contactZip
        contactPhone
        configParms
        hubspotID
        countryCode
        integrations
        restrictionType
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        docuSealAccess
        companyLogo
        coverPhoto
        legalBusinessName
        dbaName
        legalEntityType
        einTaxId
        statesOfOperation
        insuranceContactName
        insuranceContactTitle
        insuranceContactPhone
        insuranceContactEmail
        licenseNumber
        licenseIssuingState
        licenseExpirationDate
        bypassBillingCheck
        defaultEstimateDisclaimer
        standardScopeNotes
        planType
        clonedFrom
        billingType
        paymentCustomerID
        salesChannel
        selfServiceCancellation
        __typename
      }
      __typename
    }
  }
`;
export const listOrgMembers = /* GraphQL */ `
  query ListOrgMembers(
    $filter: ModelOrgMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrgMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        roleID
        orgID
        status
        memberType
        orgPoints
        lifetimeOrgPoints
        isActive
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const OrgMemberByUser = /* GraphQL */ `
  query OrgMemberByUser(
    $userID: ID
    $orgID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrgMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    OrgMemberByUser(
      userID: $userID
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        roleID
        orgID
        status
        memberType
        orgPoints
        lifetimeOrgPoints
        isActive
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCircleMember = /* GraphQL */ `
  query GetCircleMember($id: ID!) {
    getCircleMember(id: $id) {
      id
      userID
      circleID
      status
      memberType
      closerOrder
      closerWeight
      appointmentCount
      memberRole
      priority
      circlePoints
      lifetimeCirclePoints
      isActive
      orgID
      effectiveStartDate
      effectiveStartDateEpoch
      effectiveEndDate
      effectiveEndDateEpoch
      source
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listCircleMembers = /* GraphQL */ `
  query ListCircleMembers(
    $filter: ModelCircleMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCircleMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        circleID
        status
        memberType
        closerOrder
        closerWeight
        appointmentCount
        memberRole
        priority
        circlePoints
        lifetimeCirclePoints
        isActive
        orgID
        effectiveStartDate
        effectiveStartDateEpoch
        effectiveEndDate
        effectiveEndDateEpoch
        source
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const circleMemberByCircleID = /* GraphQL */ `
  query CircleMemberByCircleID(
    $circleID: ID
    $userID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCircleMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    circleMemberByCircleID(
      circleID: $circleID
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        circleID
        status
        memberType
        closerOrder
        closerWeight
        appointmentCount
        memberRole
        priority
        circlePoints
        lifetimeCirclePoints
        isActive
        orgID
        effectiveStartDate
        effectiveStartDateEpoch
        effectiveEndDate
        effectiveEndDateEpoch
        source
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCircleCloser = /* GraphQL */ `
  query ListCircleCloser(
    $circleID: ID
    $closerOrder: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCircleMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCircleCloser(
      circleID: $circleID
      closerOrder: $closerOrder
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        circleID
        status
        memberType
        closerOrder
        closerWeight
        appointmentCount
        memberRole
        priority
        circlePoints
        lifetimeCirclePoints
        isActive
        orgID
        effectiveStartDate
        effectiveStartDateEpoch
        effectiveEndDate
        effectiveEndDateEpoch
        source
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const circleMemberByUserID = /* GraphQL */ `
  query CircleMemberByUserID(
    $userID: ID
    $circleID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCircleMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    circleMemberByUserID(
      userID: $userID
      circleID: $circleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        circleID
        status
        memberType
        closerOrder
        closerWeight
        appointmentCount
        memberRole
        priority
        circlePoints
        lifetimeCirclePoints
        isActive
        orgID
        effectiveStartDate
        effectiveStartDateEpoch
        effectiveEndDate
        effectiveEndDateEpoch
        source
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const circleMemberByCircleStartDate = /* GraphQL */ `
  query CircleMemberByCircleStartDate(
    $circleID: ID
    $effectiveStartDateEpochUserID: ModelCircleMemberByCircleStartDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCircleMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    circleMemberByCircleStartDate(
      circleID: $circleID
      effectiveStartDateEpochUserID: $effectiveStartDateEpochUserID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        circleID
        status
        memberType
        closerOrder
        closerWeight
        appointmentCount
        memberRole
        priority
        circlePoints
        lifetimeCirclePoints
        isActive
        orgID
        effectiveStartDate
        effectiveStartDateEpoch
        effectiveEndDate
        effectiveEndDateEpoch
        source
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const circleMemberByUserStartDate = /* GraphQL */ `
  query CircleMemberByUserStartDate(
    $userID: ID
    $effectiveStartDateEpochCircleID: ModelCircleMemberByUserStartDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCircleMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    circleMemberByUserStartDate(
      userID: $userID
      effectiveStartDateEpochCircleID: $effectiveStartDateEpochCircleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        circleID
        status
        memberType
        closerOrder
        closerWeight
        appointmentCount
        memberRole
        priority
        circlePoints
        lifetimeCirclePoints
        isActive
        orgID
        effectiveStartDate
        effectiveStartDateEpoch
        effectiveEndDate
        effectiveEndDateEpoch
        source
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const circleMemberByCircleEndDate = /* GraphQL */ `
  query CircleMemberByCircleEndDate(
    $circleID: ID
    $effectiveEndDateEpochUserID: ModelCircleMemberByCircleEndDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCircleMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    circleMemberByCircleEndDate(
      circleID: $circleID
      effectiveEndDateEpochUserID: $effectiveEndDateEpochUserID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        circleID
        status
        memberType
        closerOrder
        closerWeight
        appointmentCount
        memberRole
        priority
        circlePoints
        lifetimeCirclePoints
        isActive
        orgID
        effectiveStartDate
        effectiveStartDateEpoch
        effectiveEndDate
        effectiveEndDateEpoch
        source
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const circleMemberByUserEndDate = /* GraphQL */ `
  query CircleMemberByUserEndDate(
    $userID: ID
    $effectiveEndDateEpochCircleID: ModelCircleMemberByUserEndDateCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCircleMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    circleMemberByUserEndDate(
      userID: $userID
      effectiveEndDateEpochCircleID: $effectiveEndDateEpochCircleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        circleID
        status
        memberType
        closerOrder
        closerWeight
        appointmentCount
        memberRole
        priority
        circlePoints
        lifetimeCirclePoints
        isActive
        orgID
        effectiveStartDate
        effectiveStartDateEpoch
        effectiveEndDate
        effectiveEndDateEpoch
        source
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCircleMission = /* GraphQL */ `
  query GetCircleMission($id: ID!) {
    getCircleMission(id: $id) {
      id
      circleID
      orgID
      startDate
      endDate
      missionID
      isPaid
      currentPosition
      previousPosition
      rewardDisposition
      doneActionCount
      goalActionCount
      rewardCount
      trophiesAwarded
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      __typename
    }
  }
`;
export const listCircleMissions = /* GraphQL */ `
  query ListCircleMissions(
    $filter: ModelCircleMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCircleMissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        circleID
        orgID
        startDate
        endDate
        missionID
        isPaid
        currentPosition
        previousPosition
        rewardDisposition
        doneActionCount
        goalActionCount
        rewardCount
        trophiesAwarded
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserMission = /* GraphQL */ `
  query GetUserMission($id: ID!) {
    getUserMission(id: $id) {
      id
      userID
      playMission
      missionID
      circleID
      status
      isCompleted
      isVerified
      isPaid
      imageName
      imageType
      doneActionCount
      goalActionCount
      location
      rewardCount
      rewardDisposition
      currentPosition
      previousPosition
      permissions
      orgID
      KPIRuleID
      action
      startDate
      endDate
      launchDate
      startDateEpoch
      endDateEpoch
      launchDateEpoch
      flexFields
      useStepCounter
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        contactDispositionFilter
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      circle {
        id
        extID
        name
        sortName
        description
        location
        scope
        inviterType
        approverType
        status
        isActive
        isHidden
        imageName
        imageType
        avatarImageName
        communityID
        startDate
        endDate
        launchDate
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        parentCircleID
        levelID
        colorCode
        fieldRoutesOfficeID
        flexAttributes
        tangoAccountID
        isLeague
        hasWanderMode
        hasRoundRobin
        defaultSchedulerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        useRecordingConsent
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      actions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listUserMissions = /* GraphQL */ `
  query ListUserMissions(
    $filter: ModelUserMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserMissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        playMission
        missionID
        circleID
        status
        isCompleted
        isVerified
        isPaid
        imageName
        imageType
        doneActionCount
        goalActionCount
        location
        rewardCount
        rewardDisposition
        currentPosition
        previousPosition
        permissions
        orgID
        KPIRuleID
        action
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        flexFields
        useStepCounter
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const UserMissionByUserIdLaunchDate = /* GraphQL */ `
  query UserMissionByUserIdLaunchDate(
    $userID: ID
    $launchDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    UserMissionByUserIdLaunchDate(
      userID: $userID
      launchDate: $launchDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        playMission
        missionID
        circleID
        status
        isCompleted
        isVerified
        isPaid
        imageName
        imageType
        doneActionCount
        goalActionCount
        location
        rewardCount
        rewardDisposition
        currentPosition
        previousPosition
        permissions
        orgID
        KPIRuleID
        action
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        flexFields
        useStepCounter
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const UserMissionByUserIdStartDate = /* GraphQL */ `
  query UserMissionByUserIdStartDate(
    $userID: ID
    $startDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    UserMissionByUserIdStartDate(
      userID: $userID
      startDate: $startDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        playMission
        missionID
        circleID
        status
        isCompleted
        isVerified
        isPaid
        imageName
        imageType
        doneActionCount
        goalActionCount
        location
        rewardCount
        rewardDisposition
        currentPosition
        previousPosition
        permissions
        orgID
        KPIRuleID
        action
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        flexFields
        useStepCounter
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const byUserKPIRuleID = /* GraphQL */ `
  query ByUserKPIRuleID(
    $userID: ID
    $KPIRuleID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserMissionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byUserKPIRuleID(
      userID: $userID
      KPIRuleID: $KPIRuleID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        playMission
        missionID
        circleID
        status
        isCompleted
        isVerified
        isPaid
        imageName
        imageType
        doneActionCount
        goalActionCount
        location
        rewardCount
        rewardDisposition
        currentPosition
        previousPosition
        permissions
        orgID
        KPIRuleID
        action
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        flexFields
        useStepCounter
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserMissionAction = /* GraphQL */ `
  query GetUserMissionAction($id: ID!) {
    getUserMissionAction(id: $id) {
      id
      userMissionID
      userID
      missionID
      ownerID
      KPIRuleID
      ruleRole
      actionCount
      currentActionCount
      rewardCount
      currentRewardCount
      comments
      imageName
      imageType
      extID
      dealID
      flexAttributes
      goalCount
      actionTimestamp
      orgID
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      KPIRule {
        id
        orgID
        type
        timeframe
        title
        abbreviation
        sourceType
        formula
        triggerID
        dimensions
        action
        actionPastTense
        valueUnit
        valueUnitPlural
        categoryID
        viewerRoles
        leaderboardViewerRoles
        scorecardViewerRoles
        order
        editorRoles
        functionalRoles
        eventCreatorScope
        contactDispositionFilter
        entitlement
        isHidden
        useDateOfStage
        format
        roundPrecision
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      userMission {
        id
        userID
        playMission
        missionID
        circleID
        status
        isCompleted
        isVerified
        isPaid
        imageName
        imageType
        doneActionCount
        goalActionCount
        location
        rewardCount
        rewardDisposition
        currentPosition
        previousPosition
        permissions
        orgID
        KPIRuleID
        action
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        flexFields
        useStepCounter
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listUserMissionActions = /* GraphQL */ `
  query ListUserMissionActions(
    $filter: ModelUserMissionActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserMissionActions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userMissionID
        userID
        missionID
        ownerID
        KPIRuleID
        ruleRole
        actionCount
        currentActionCount
        rewardCount
        currentRewardCount
        comments
        imageName
        imageType
        extID
        dealID
        flexAttributes
        goalCount
        actionTimestamp
        orgID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReward = /* GraphQL */ `
  query GetReward($id: ID!) {
    getReward(id: $id) {
      id
      name
      description
      rewardType
      personLimit
      limitCount
      value
      valueType
      remainingCount
      imageName
      imageType
      tags
      validFrom
      validTo
      launchDate
      isActive
      cost
      costType
      giftcardValue
      minGiftcardAmount
      maxGiftcardAmount
      utid
      tangoAccountID
      ownerType
      ownerID
      approverType
      location
      giftcardDisclaimer
      orgID
      nextLaunchFeedBlast
      nextExpireFeedBlast
      permissions
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      missions {
        nextToken
        __typename
      }
      users {
        nextToken
        __typename
      }
      userdetails {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listRewards = /* GraphQL */ `
  query ListRewards(
    $filter: ModelRewardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRewards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRewardsByOrgName = /* GraphQL */ `
  query ListRewardsByOrgName(
    $orgID: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRewardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRewardsByOrgName(
      orgID: $orgID
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserReward = /* GraphQL */ `
  query GetUserReward($id: ID!) {
    getUserReward(id: $id) {
      id
      userID
      rewardID
      purchaseType
      status
      purchaseCount
      permissions
      orgID
      approverID
      errorMessages
      statusTmst
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      details {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listUserRewards = /* GraphQL */ `
  query ListUserRewards(
    $filter: ModelUserRewardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserRewards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        rewardID
        purchaseType
        status
        purchaseCount
        permissions
        orgID
        approverID
        errorMessages
        statusTmst
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserRewardsByUserReward = /* GraphQL */ `
  query ListUserRewardsByUserReward(
    $userID: ID
    $rewardID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserRewardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserRewardsByUserReward(
      userID: $userID
      rewardID: $rewardID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        rewardID
        purchaseType
        status
        purchaseCount
        permissions
        orgID
        approverID
        errorMessages
        statusTmst
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserRewardsByOrgCreatedAt = /* GraphQL */ `
  query ListUserRewardsByOrgCreatedAt(
    $orgID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserRewardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserRewardsByOrgCreatedAt(
      orgID: $orgID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        rewardID
        purchaseType
        status
        purchaseCount
        permissions
        orgID
        approverID
        errorMessages
        statusTmst
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserLocation = /* GraphQL */ `
  query GetUserLocation($id: ID!) {
    getUserLocation(id: $id) {
      id
      userID
      orgID
      location {
        lat
        lon
        __typename
      }
      batteryLevel
      deviceInfo
      appVersion
      transactionCounts
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      __typename
    }
  }
`;
export const listUserLocations = /* GraphQL */ `
  query ListUserLocations(
    $filter: ModelUserLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        orgID
        batteryLevel
        deviceInfo
        appVersion
        transactionCounts
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLeadTransaction = /* GraphQL */ `
  query GetLeadTransaction($id: ID!) {
    getLeadTransaction(id: $id) {
      id
      leadAreaID
      leadArea {
        id
        orgID
        name
        purchaseDate
        quantityOfLeads
        remainingLeads
        minimumPurchaseQuantity
        perLeadPrice
        daysToExpire
        initialPurchaseQuantity
        initialPurchasePrice
        totalCost
        pricePerLead
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      orgID
      transactionType
      transactionDate
      amount
      currency
      stripeTransactionID
      stripePaymentIntentID
      status
      metadata
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listLeadTransactions = /* GraphQL */ `
  query ListLeadTransactions(
    $filter: ModelLeadTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLeadTransactions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        leadAreaID
        orgID
        transactionType
        transactionDate
        amount
        currency
        stripeTransactionID
        stripePaymentIntentID
        status
        metadata
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTransactionsByLeadArea = /* GraphQL */ `
  query ListTransactionsByLeadArea(
    $leadAreaID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelLeadTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactionsByLeadArea(
      leadAreaID: $leadAreaID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        leadAreaID
        orgID
        transactionType
        transactionDate
        amount
        currency
        stripeTransactionID
        stripePaymentIntentID
        status
        metadata
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTransactionsByOrg = /* GraphQL */ `
  query ListTransactionsByOrg(
    $orgID: ID
    $transactionDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelLeadTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactionsByOrg(
      orgID: $orgID
      transactionDate: $transactionDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        leadAreaID
        orgID
        transactionType
        transactionDate
        amount
        currency
        stripeTransactionID
        stripePaymentIntentID
        status
        metadata
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTransactionsByStripeID = /* GraphQL */ `
  query ListTransactionsByStripeID(
    $stripeTransactionID: String
    $sortDirection: ModelSortDirection
    $filter: ModelLeadTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactionsByStripeID(
      stripeTransactionID: $stripeTransactionID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        leadAreaID
        orgID
        transactionType
        transactionDate
        amount
        currency
        stripeTransactionID
        stripePaymentIntentID
        status
        metadata
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserRewardDetails = /* GraphQL */ `
  query GetUserRewardDetails($id: ID!) {
    getUserRewardDetails(id: $id) {
      id
      userRewardID
      userID
      rewardID
      orgID
      missionID
      purchaseType
      status
      errorMessages
      statusTmst
      purchaseCount
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      mission {
        id
        type
        contestType
        name
        description
        rewardLimit
        rewardCount
        rewardType
        actionPastTense
        actionTypePlural
        rewardID
        rewardName
        scope
        ownerID
        ownerType
        startDate
        endDate
        launchDate
        startDateEpoch
        endDateEpoch
        launchDateEpoch
        KPIRuleID
        tieKPIRuleID
        imageName
        imageType
        questType
        questOrder
        location
        actionCount
        action
        actionType
        minGoal
        actionCountType
        completePictureRequired
        isDeleted
        nextLaunchFeedBlast
        nextExpireFeedBlast
        tags
        bracket
        orgID
        mostRecentUserID
        trophiesAwarded
        rewardsAwarded
        bracketWinner
        autoAssign
        assignToChildCircles
        autoCreateMonths
        permissions
        categoryID
        flexFields
        useStepCounter
        isCircleOnly
        isPublic
        rewardDisposition
        useAutoGoal
        autoGoalTimeframe
        autoGoalTimeframeCount
        autoGoalFactor
        minAutoGoal
        roundGoalPrecision
        advanceType
        nextMissionID
        topNumberAdvance
        useAutoCreate
        autoCreateTimeframe
        autoCreateTimeframeCount
        autoCreateStartDate
        autoCreateEndDate
        isHidden
        competitors
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      reward {
        id
        name
        description
        rewardType
        personLimit
        limitCount
        value
        valueType
        remainingCount
        imageName
        imageType
        tags
        validFrom
        validTo
        launchDate
        isActive
        cost
        costType
        giftcardValue
        minGiftcardAmount
        maxGiftcardAmount
        utid
        tangoAccountID
        ownerType
        ownerID
        approverType
        location
        giftcardDisclaimer
        orgID
        nextLaunchFeedBlast
        nextExpireFeedBlast
        permissions
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      userReward {
        id
        userID
        rewardID
        purchaseType
        status
        purchaseCount
        permissions
        orgID
        approverID
        errorMessages
        statusTmst
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listUserRewardDetailss = /* GraphQL */ `
  query ListUserRewardDetailss(
    $filter: ModelUserRewardDetailsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserRewardDetailss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userRewardID
        userID
        rewardID
        orgID
        missionID
        purchaseType
        status
        errorMessages
        statusTmst
        purchaseCount
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserGiftcardAccount = /* GraphQL */ `
  query GetUserGiftcardAccount($id: ID!) {
    getUserGiftcardAccount(id: $id) {
      id
      userID
      orgID
      name
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      circles {
        nextToken
        __typename
      }
      user {
        id
        extID
        username
        email
        phoneNumber
        name
        birthdate
        imageName
        imageType
        location
        nameVisibility
        phoneNumberVisibility
        emailVisibility
        birthdateVisibility
        pictureVisibility
        locationVisibility
        initials
        pronoun
        role
        functionalRoles
        status
        expoToken
        orgID
        title
        externalTitle
        externalName
        externalEmail
        externalPhoneNumber
        externalBio
        categories
        avatarID
        levelID
        agreedToTerms
        agreedToTermsAt
        tags
        colorCode
        hasWanderMode
        hasRoundRobin
        flexAttributes
        defaultCategoryID
        allowedCategoryIDs
        stripeCustomerID
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        excludeFromBilling
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listUserGiftcardAccounts = /* GraphQL */ `
  query ListUserGiftcardAccounts(
    $filter: ModelUserGiftcardAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserGiftcardAccounts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        orgID
        name
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserGiftCardAccountByUser = /* GraphQL */ `
  query ListUserGiftCardAccountByUser(
    $userID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUserGiftcardAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserGiftCardAccountByUser(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        orgID
        name
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserTask = /* GraphQL */ `
  query GetUserTask($id: ID!) {
    getUserTask(id: $id) {
      id
      orgID
      userID
      dueDate
      expire
      dealID
      createdBy
      completedTmst
      title
      description
      isCompleted
      isRead
      priority
      isArchived
      flexAttributes
      isDeleted
      createdAt
      updatedAt
      deal {
        id
        orgID
        categoryID
        isContract
        customerID
        dealTypeID
        extID
        name
        sortName
        description
        searchString
        ownersString
        officeID
        value
        notes
        status
        currentStageID
        currentOwnerID
        defaultCircleID
        currentOwnerType
        currentDispositionID
        nextFollowupDate
        reminderSentTmst
        flexAttributes
        previousFlexAttributes
        lastInspectionType
        lastInspectionTmst
        imageName
        imageType
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      __typename
    }
  }
`;
export const listUserTasks = /* GraphQL */ `
  query ListUserTasks(
    $filter: ModelUserTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        userID
        dueDate
        expire
        dealID
        createdBy
        completedTmst
        title
        description
        isCompleted
        isRead
        priority
        isArchived
        flexAttributes
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTasksByUser = /* GraphQL */ `
  query ListTasksByUser(
    $userID: ID
    $dueDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasksByUser(
      userID: $userID
      dueDate: $dueDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        dueDate
        expire
        dealID
        createdBy
        completedTmst
        title
        description
        isCompleted
        isRead
        priority
        isArchived
        flexAttributes
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTasksByOrg = /* GraphQL */ `
  query ListTasksByOrg(
    $orgID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUserTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasksByOrg(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        dueDate
        expire
        dealID
        createdBy
        completedTmst
        title
        description
        isCompleted
        isRead
        priority
        isArchived
        flexAttributes
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listTasksByDealID = /* GraphQL */ `
  query ListTasksByDealID(
    $dealID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUserTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasksByDealID(
      dealID: $dealID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        userID
        dueDate
        expire
        dealID
        createdBy
        completedTmst
        title
        description
        isCompleted
        isRead
        priority
        isArchived
        flexAttributes
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserRole = /* GraphQL */ `
  query GetUserRole($id: ID!) {
    getUserRole(id: $id) {
      id
      orgID
      isDeleted
      roleName
      permissions
      isSuper
      iconName
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserRoles = /* GraphQL */ `
  query ListUserRoles(
    $filter: ModelUserRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        isDeleted
        roleName
        permissions
        isSuper
        iconName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRolesByOrg = /* GraphQL */ `
  query ListRolesByOrg(
    $orgID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelUserRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRolesByOrg(
      orgID: $orgID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        isDeleted
        roleName
        permissions
        isSuper
        iconName
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAgentContextEvent = /* GraphQL */ `
  query GetAgentContextEvent($id: ID!) {
    getAgentContextEvent(id: $id) {
      id
      orgID
      dealID
      taskListID
      agent
      eventType
      schemaVersion
      ts
      sortOrder
      payload
      createdBy
      createdAt
      updatedAt
      isDeleted
      __typename
    }
  }
`;
export const listAgentContextEvents = /* GraphQL */ `
  query ListAgentContextEvents(
    $filter: ModelAgentContextEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentContextEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        taskListID
        agent
        eventType
        schemaVersion
        ts
        sortOrder
        payload
        createdBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAgentContextEventByDealID = /* GraphQL */ `
  query ListAgentContextEventByDealID(
    $dealID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAgentContextEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentContextEventByDealID(
      dealID: $dealID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        taskListID
        agent
        eventType
        schemaVersion
        ts
        sortOrder
        payload
        createdBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAgentContextEventByTaskListID = /* GraphQL */ `
  query ListAgentContextEventByTaskListID(
    $taskListID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAgentContextEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentContextEventByTaskListID(
      taskListID: $taskListID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        taskListID
        agent
        eventType
        schemaVersion
        ts
        sortOrder
        payload
        createdBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAgentContextEventByOrgID = /* GraphQL */ `
  query ListAgentContextEventByOrgID(
    $orgID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAgentContextEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentContextEventByOrgID(
      orgID: $orgID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        taskListID
        agent
        eventType
        schemaVersion
        ts
        sortOrder
        payload
        createdBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAgentSession = /* GraphQL */ `
  query GetAgentSession($id: ID!) {
    getAgentSession(id: $id) {
      id
      orgID
      dealID
      taskListID
      agent
      userID
      status
      schemaVersion
      sessionStartedAt
      taskList
      gapAnalysis
      createdBy
      lastUpdatedBy
      createdAt
      updatedAt
      isDeleted
      events {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const listAgentSessions = /* GraphQL */ `
  query ListAgentSessions(
    $filter: ModelAgentSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentSessions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        dealID
        taskListID
        agent
        userID
        status
        schemaVersion
        sessionStartedAt
        taskList
        gapAnalysis
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAgentSessionByDealID = /* GraphQL */ `
  query ListAgentSessionByDealID(
    $dealID: ID
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAgentSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentSessionByDealID(
      dealID: $dealID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        taskListID
        agent
        userID
        status
        schemaVersion
        sessionStartedAt
        taskList
        gapAnalysis
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAgentSessionByTaskListID = /* GraphQL */ `
  query ListAgentSessionByTaskListID(
    $taskListID: ID
    $sortDirection: ModelSortDirection
    $filter: ModelAgentSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentSessionByTaskListID(
      taskListID: $taskListID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        taskListID
        agent
        userID
        status
        schemaVersion
        sessionStartedAt
        taskList
        gapAnalysis
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAgentSessionByOrgID = /* GraphQL */ `
  query ListAgentSessionByOrgID(
    $orgID: ID
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAgentSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentSessionByOrgID(
      orgID: $orgID
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgID
        dealID
        taskListID
        agent
        userID
        status
        schemaVersion
        sessionStartedAt
        taskList
        gapAnalysis
        createdBy
        lastUpdatedBy
        createdAt
        updatedAt
        isDeleted
        __typename
      }
      nextToken
      __typename
    }
  }
`;
